// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-11-03T20:37:46.632Z
// Property: City Harbor (ID: 5694569974857728)
// Collections: 15 amenities, 3 floorplans (live), 32 photos, 79 POIs, 3 reviews, 1 virtual tours, 6 office hours, 1 special offers (live), 17 faqs
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5695708787113984",
  "multihub_property_id": "5694569974857728",
  "property_external_id": "4881700",
  "property_zillow_url": "https://www.zillow.com/apartments/melbourne-fl/waverly-place/5hQWsR/",
  "property_apartments_url": "https://www.apartments.com/city-harbor-melbourne-fl/sq22vq5",
  "property_google_business_url": "https://www.google.com/maps/place/City+Harbor/@28.1464304,-80.6653984,15z/data=!4m2!3m1!1s0x0:0xd3ba213e7c8ace95?sa=X&ved=2ahUKEwielqrb8uH2AhXok2oFHYSmClYQ_BJ6BAgqEAU",
  "property_linkedin_url": null,
  "property_hubspot_id": "8443932491",
  "property_crm_software": "Rent Dynamics",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "city-harbor",
  "property_name": "City Harbor",
  "property_website_url": "https://www.cityharborapts.com/",
  "property_domain": "https://www.cityharborapts.com/",
  "property_address": "2395 Woodwind Trl",
  "property_full_address": "2395 Woodwind Trail, Melbourne, FL 32935",
  "property_address_1": "2395 Woodwind Trail",
  "property_address_2": null,
  "property_address_city": "Melbourne",
  "property_address_state": "FL",
  "property_address_zip_full": "32935-2151",
  "property_address_zip": "32935",
  "property_address_country": "US",
  "property_address_county": "Brevard County",
  "property_neighborhood_address": "Melbourne",
  "property_address_latitude": "28.1464402",
  "property_address_longitude": "-80.66539499999999",
  "property_email": "cityharbor@alapts.com",
  "property_phone": "(321) 242-9191",
  "property_call_tracking_phone": "689-588-5048",
  "property_company_name": "American Landmark",
  "property_company_url": "https://www.alapts.com/",
  "agency_contacts": null,
  "property_type": "apartment",
  "property_short_description": "<p><strong>Relaxed Melbourne living starts here.</strong> Discover City Harbor’s one-, two-, and three-bedroom apartments with polished finishes, a quiet lake setting, and resort-inspired spaces made for everyday ease—then schedule your tour to see it all in person.</p>",
  "property_long_description": "<p><strong>Settle into relaxed Melbourne living at City Harbor,</strong> where a quiet, park-like setting with a community lake meets resort-inspired spaces made for everyday ease. Choose from one-, two-, and three-bedroom <a href=\"/floor-plans\">apartment layouts</a> with polished finishes like stainless-steel appliances, granite countertops, decorative backsplashes, wood-style flooring, and airy 9' ceilings, with in-home washer and dryer options available in select residences.</p><p>Outside your door, unwind by the <a href=\"/amenities\">pool with cabanas</a>, fire up dinner at the outdoor kitchen with gas grills, get moving in the modern fitness center with a workout mirror, or gather in the resident entertainment room. Your address near Mallards Landing Golf Course keeps daily essentials close, with Lake Washington Crossing less than a mile away and quick access to Lake Washington Road and US-1.</p><p>When you’re ready to explore, the <a href=\"/neighborhood\">Eau Gallie Arts District</a>, Wickham Park, Erna Nixon Park, Melbourne Orlando International Airport, and Canova Beach Park are all within an easy drive—bringing Space Coast convenience, dining, art, nature, and shoreline escapes into your routine.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019d02f1-aa08-733b-97b4-1a404d227eee.webp",
  "property_featured_image_media": {
    "alt_text": "Modern living room with a desk area, sofa, TV, and a wooden accent chair.",
    "public_id": "019d02f1-aa08-733b-97b4-1a404d227eee",
    "storage_key": "property/5694569974857728/019d02f1-aa08-733b-97b4-1a404d227eee.webp",
    "width": 1240,
    "height": 826
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "208",
  "property_year_built": "1987",
  "property_year_renovated": "2022",
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "92.3076923076923",
  "property_admin_fee": "250",
  "property_application_fee": "100",
  "property_fees_deposit_info": "Application Fee: $100\nAdministrative Fee: $250\nApplication Approval Fee: Starting at $399\nPet Fee: $300 per pet\nMonthly Pet Rent: $30/pet",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "300",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "30",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "Breed restrictions may apply. Contact us for more information.",
  "property_pet_policy_description": "We happily accept cats and dogs, up to 2 per home, with no weight limit. We have a one-time non-refundable pet fee of $300 per pet, with a monthly pet rent of $30 per pet. Breed restrictions may apply.",
  "property_petpolicy_info": "We happily accept cats and dogs, up to 2 per home, with no weight limit. We have a one-time non-refundable pet fee of $300 per pet, with a monthly pet rent of $30 per pet. Breed restrictions may apply.",
  "property_online_leasing_url": "https://8778159.onlineleasing.realpage.com",
  "property_resident_portal_url": "https://cityharbor.loftliving.com/login",
  "property_apply_now_url": "https://8778159.onlineleasing.realpage.com",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019e4d09-25c7-754d-9594-afd1229b7644.webp",
  "property_primary_logo_media": {
    "alt_text": "City Harbor Premier Apartments logo",
    "public_id": "019e4d09-25c7-754d-9594-afd1229b7644",
    "storage_key": "property/5694569974857728/019e4d09-25c7-754d-9594-afd1229b7644.webp",
    "width": 2038,
    "height": 917
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019e4d08-e21f-739f-9863-ec10916d193a.webp",
  "property_secondary_logo_media": {
    "alt_text": "City Harbor Premier Apartments logo",
    "public_id": "019e4d08-e21f-739f-9863-ec10916d193a",
    "storage_key": "property/5694569974857728/019e4d08-e21f-739f-9863-ec10916d193a.webp",
    "width": 2038,
    "height": 917
  },
  "property_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019e4d08-a85c-725e-b25c-c2fc30173c82.webp",
  "property_icon_media": {
    "alt_text": "Circle logo with H in the center",
    "public_id": "019e4d08-a85c-725e-b25c-c2fc30173c82",
    "storage_key": "property/5694569974857728/019e4d08-a85c-725e-b25c-c2fc30173c82.webp",
    "width": 607,
    "height": 607
  },
  "property_fav_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019e4d08-a85c-725e-b25c-c2fc30173c82.webp",
  "property_fav_icon_media": {
    "alt_text": "Circle logo with H in the center",
    "public_id": "019e4d08-a85c-725e-b25c-c2fc30173c82",
    "storage_key": "property/5694569974857728/019e4d08-a85c-725e-b25c-c2fc30173c82.webp",
    "width": 607,
    "height": 607
  },
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019e4d08-65c4-74e1-8d79-6276d1289342.webp",
  "property_mono_white_logo_media": {
    "alt_text": "City Harbor Premier Apartments logo.",
    "public_id": "019e4d08-65c4-74e1-8d79-6276d1289342",
    "storage_key": "property/5694569974857728/019e4d08-65c4-74e1-8d79-6276d1289342.webp",
    "width": 2038,
    "height": 917
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019e4d09-a02b-77be-adf6-a70331fd9598.webp",
  "property_mono_black_logo_media": {
    "alt_text": "City Harbor Premier Apartments logo.",
    "public_id": "019e4d09-a02b-77be-adf6-a70331fd9598",
    "storage_key": "property/5694569974857728/019e4d09-a02b-77be-adf6-a70331fd9598.webp",
    "width": 2038,
    "height": 917
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-af4c-707a-be5f-eaefee6b31cf.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-c9dc-7579-9b73-fbe42f847d6f.webp",
  "property_company_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02ed-c9dc-7579-9b73-fbe42f847d6f",
    "storage_key": "company/5695708787113984/019d02ed-c9dc-7579-9b73-fbe42f847d6f.webp",
    "width": 1968,
    "height": 884
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-b73c-7581-ab8a-b01c3434f867.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02ed-b73c-7581-ab8a-b01c3434f867",
    "storage_key": "company/5695708787113984/019d02ed-b73c-7581-ab8a-b01c3434f867.webp",
    "width": 2565,
    "height": 1000
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-bfec-74fd-b5d0-5a699636306b.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "American Landmark logo on a black background",
    "public_id": "019d02ed-bfec-74fd-b5d0-5a699636306b",
    "storage_key": "company/5695708787113984/019d02ed-bfec-74fd-b5d0-5a699636306b.webp",
    "width": 2565,
    "height": 1000
  },
  "property_primary_color": "#276092",
  "property_secondary_color": "#62b9af",
  "property_font_color": "#2e2a25",
  "property_color_4": null,
  "property_color_3": "#a4a9ad",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "700 - 1025",
  "property_sqft_min": "700",
  "property_sqft_max": "1025",
  "property_price_range": "1306.66 - 2038",
  "property_price_min": "1306.66",
  "property_price_max": "2038",
  "property_available_units": 16,
  "property_facebook_url": "https://www.facebook.com/cityharborapartments",
  "property_instagram_url": "https://www.instagram.com/cityharborapts",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJw4Oek5cP3ogRlc6KfD4hutM",
  "property_youtube_url": "https://www.youtube.com/@CityHarborApartments",
  "property_yelp_url": "https://www.yelp.com/biz/landmark-at-waverly-place-melbourne-2",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": null,
  "property_home_romance_title": null,
  "property_home_amenities_blurb": "<p><strong>Spaces that keep pace with your day.</strong> Start in the modern fitness center with a workout mirror, unwind by the pool beneath cabanas, or stay connected with poolside Wi‑Fi. Evenings feel easy at the outdoor kitchen with gas grills, while apartment finishes like stainless-steel appliances, granite countertops, decorative backsplashes, wood-style flooring, and 9' ceilings bring a polished edge to everyday living.</p>",
  "property_home_floorplans_blurb": "<p><strong>Layouts that make choosing feel simple.</strong> Explore one-, two-, and three-bedroom apartments in Melbourne with open living spaces, smart bedroom separation, and kitchens finished with stainless-steel appliances, granite countertops, and decorative backsplashes. Select homes add everyday ease with wood-style flooring, airy 9' ceilings, and in-home washer and dryer options—so you can compare the details that matter, then find the floor plan that fits.</p>",
  "property_home_gallery_blurb": "<p><strong>Preview the City Harbor look.</strong> From stainless-steel kitchens with granite countertops and white cabinetry to wood-style flooring, sunlit living spaces, and smart work-from-home nooks, the gallery brings the details into view. Step outside through photos of the resort-inspired pool, cabanas, grill station, clubhouse lounge, fitness center, walking paths, and landscaped green spaces—then view the full gallery to see more of City Harbor in Melbourne.</p>",
  "property_home_neighborhood_blurb": "<p><strong>Lagoon days, mural-lined nights.</strong> City Harbor places Melbourne conveniences close to EGAD’s creative energy, from coffee and groceries along Lake Washington to Highland Avenue’s murals, galleries, FM Pizza, Anaya Coffee, and Dolly’s Wine Bar. For fresh air, Ballard Park, the Eau Gallie pier, and the causeway to the beach keep the Space Coast rhythm easy to reach.</p>",
  "property_home_reviews_blurb": "<p><strong>Residents are talking about the care behind City Harbor.</strong> Reviews call out knowledgeable, friendly service, quick help with requests, and a move-in experience made easier with prepared paperwork and a clean, ready apartment.</p><p>They also mention the gardens, swimming pool, and tranquil Melbourne setting—details that make everyday life here stand out. Read more to see what City Harbor residents are sharing.</p>",
  "property_neighborhood_blurb": "<p><strong>From lagoon light to mural-lined nights.</strong> At City Harbor, Melbourne’s everyday conveniences sit close to the city’s creative side. Head down the Lake Washington corridor for coffee, groceries, and casual dining, then follow Eau Gallie Boulevard toward EGAD, where Highland Avenue brings together colorful murals, galleries, Pineapples, FM Pizza, Anaya Coffee, and Dolly’s Wine Bar near Eau Gallie Square.</p><p>When the day calls for fresh air, Ballard Park and the Eau Gallie Public Library pier put the Indian River Lagoon within easy reach, while the Eau Gallie Causeway carries you toward beachside breezes. Back home, compare <a href=\"/floor-plans\">one-, two-, and three-bedroom layouts</a> or plan a visit through the interactive map to see how City Harbor connects you to the Space Coast rhythm.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p><strong>Amenity spaces made for momentum and downtime.</strong> At City Harbor, your routine can shift easily from a workout in the modern fitness center with a workout mirror to a poolside reset under the cabanas. Keep your connection going with Wi‑Fi available at the pool, or make the most of Florida evenings at the outdoor kitchen with gas grills.</p><p>Inside your apartment, polished finishes bring a clean, contemporary feel to everyday living. Stainless-steel appliances, sleek granite countertops, decorative backsplashes, wood-style flooring, and 9' ceilings create a bright backdrop, while in-home washer and dryer options add convenience in select residences. Resident services like online access, RentPlus credit-building tools, and available Spruce cleaning services help simplify the details so your home in Melbourne works as well as it looks.</p>",
  "property_applynow_blurb": "<p><strong>Ready to make City Harbor home?</strong><br>Start your online application for relaxed Melbourne living with polished one-, two-, and three-bedroom layouts, park-like surroundings, and everyday resort-inspired spaces designed for ease. Your next apartment is within reach—apply now and take the next step.</p>",
  "property_contactus_blurb": "<p><strong>Have questions about City Harbor?</strong> Connect with our leasing team for details on available layouts, polished apartment finishes, or directions to our relaxed Melbourne setting near everyday conveniences. We’re here to help you take the next step.</p>",
  "property_faqs_blurb": "<p><strong>Questions about City Harbor?</strong> Start here for helpful answers about the community, leasing, apartment layouts, amenities, and everyday living in this relaxed Melbourne setting. If you don’t see what you need, the leasing team is happy to help you take the next step.</p>",
  "property_floorplans_blurb": "<p><strong>Find the floor plan that fits your everyday rhythm.</strong> City Harbor offers one-, two-, and three-bedroom apartments in Melbourne with thoughtfully arranged spaces that make it easy to compare your next home at a glance. Browse layouts with open living areas, practical bedroom separation, and kitchens designed for real use—complete with stainless-steel appliances, sleek granite countertops, and decorative backsplashes.</p><p>Choose a cozy one-bedroom, a well-balanced two-bedroom, or a roomier three-bedroom layout, then look for details that elevate the day-to-day, like wood-style flooring, airy 9' ceilings, and in-home washer and dryer options in select residences. After you explore current pricing and availability, view more <a href=\"/amenities\">apartment features</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see your favorite layout in person.</p>",
  "property_gallery_blurb": "<p><strong>See the spaces that set the tone.</strong> Browse City Harbor’s photo gallery for a closer look at apartment interiors, amenity spaces, and open-air corners that bring the community into focus. Picture bright kitchens with stainless-steel appliances, granite countertops, and clean white cabinetry; living areas with wood-style flooring and easy natural light; and bedrooms, baths, closets, and work-from-home nooks arranged for everyday flow.</p><p>Outside, the camera moves from the resort-inspired pool and cabanas to the grill station, clubhouse lounge, fitness center, walking paths, and landscaped green views. As you scroll, compare the scenes that matter most—then explore <a href=\"/virtual-tours\">virtual tours</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see City Harbor in Melbourne up close.</p>",
  "property_interactivemap_blurb": "<p><strong>Find your way around City Harbor.</strong> Use the interactive map to explore available apartments in a quiet, park-like Melbourne setting near daily essentials, major roads, and easy-drive access to Space Coast dining, art, nature, and shoreline escapes.</p>",
  "property_pets_blurb": "<p><strong>Pet-friendly comfort, without the weigh-in.</strong> At City Harbor, cats and dogs can settle in with you—up to two per home, with no weight limit and breed restrictions that may apply. Your daily routine feels easier with wood-style flooring, select in-home washers and dryers, and layouts that give beds, bowls, toys, and sunny naps their own place.</p><p>Step outside for fresh air around the community’s quiet, park-like setting, then head out when it’s time for a bigger stretch: Wickham Park’s off-leash dog park offers separate small- and large-dog areas nearby in Melbourne. Explore <a href=\"/floor-plans\">available floor plans</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to picture life here with your four-legged roommate.</p>",
  "property_referafriend_blurb": "<p><strong>Share relaxed Melbourne living.</strong> If City Harbor’s quiet, park-like setting, community lake, polished apartment finishes, and resort-inspired spaces are part of what makes home feel easy, invite a friend to discover it too. Send a referral and help them find their next apartment here.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident Access at City Harbor.</strong><br>Keep everyday living simple from your quiet, park-like Melbourne community. Log in to pay rent, submit maintenance requests, and manage account details—so you can get back to enjoying the ease of life at City Harbor.</p>",
  "property_reviews_blurb": "<p><strong>Hear from City Harbor residents in their own words.</strong> Reviews highlight a team that is “knowledgeable and friendly,” quick to help with requests, and attentive throughout the move-in process.</p><p>From paperwork prepared in advance to a clean, ready apartment on arrival, residents describe service that makes each step feel smoother. They also call out the gardens, swimming pool, and tranquil setting—along with staff who “shows that they care for their residents.” Explore the reviews below to see how everyday experiences at City Harbor in Melbourne are making an impression.</p>",
  "property_created_at": "1752256531628",
  "property_scheduletour_blurb": "<p><strong>See relaxed Melbourne living up close.</strong> Tour City Harbor’s park-like setting, community lake, polished apartment finishes, and resort-inspired spaces made for everyday ease—then picture how one-, two-, or three-bedroom living could feel here. Schedule your visit today.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you—your inquiry has been received.</strong><br>City Harbor’s leasing team will be in touch soon. In the meantime, picture relaxed Melbourne living in a quiet, park-like setting with a community lake, polished apartment finishes, and resort-inspired spaces designed for everyday ease.</p>",
  "property_virtualtours_blurb": "<p><strong>Preview the community at your own pace.</strong> Start with the City Harbor Community Tour and get a feel for the shared spaces that shape everyday life here—from sunlit poolside seating and cabana moments to the outdoor kitchen, fitness area, and resident lounge atmosphere. The walkthrough helps you picture how the community flows before you schedule an in-person visit in Melbourne.</p><p>Use the virtual tour to narrow your must-sees, then explore the <a href=\"/gallery\">photo gallery</a> for more angles or <a href=\"/schedule-a-tour\">schedule a tour</a> when you’re ready to see City Harbor beyond the screen.</p>",
  "property_copyright": "2025 All Rights Reserved. City Harbor",
  "property_seo_title_home": "City Harbor | Apartments in Melbourne, FL",
  "property_seo_description_home": "Discover your dream home at City Harbor in Melbourne, FL! Our stunning community features spacious one, two, and three-bedroom floor plans with modern amenities like a fitness center, outdoor kitchen, and sparkling pool. Enjoy luxury finishes, tall ceilings, and breathtaking lake views from select homes. With online resident services and convenient washer/dryer connections, comfort and convenience are just steps away. Explore all that City Harbor has to offer and find your new home today!",
  "property_seo_title_floorplans": "Floor Plans | 1 - 3 Apartments in Melbourne, FL",
  "property_seo_description_floorplans": "Discover your ideal living space at City Harbor in Melbourne, FL! Explore our diverse floor plans, featuring spacious one, two, and three-bedroom apartments designed for your comfort. Whether you’re seeking cozy nooks or expansive layouts, we have something for everyone. Browse our available apartment homes today and find your perfect floor plan at City Harbor!",
  "property_seo_title_amenities": "Amenities | Melbourne, FL Apartments for Rent",
  "property_seo_description_amenities": "Experience luxury living at City Harbor in Melbourne, FL! Explore our stunning one, two, and three-bedroom floor plans featuring vaulted ceilings, sleek tile backsplashes, and modern kitchen appliances. Enjoy resort-style amenities like a refreshing pool, state-of-the-art fitness center, and inviting outdoor kitchen. With online resident services and WiFi by the pool and clubhouse, convenience is at your fingertips. Discover the perfect blend of comfort and community — explore our amazing amenities today!",
  "property_seo_title_gallery": "Gallery | Apartments in Melbourne, FL",
  "property_seo_description_gallery": "Explore City Harbor, your dream apartment community in Melbourne, FL! Choose from stylish one, two, and three-bedroom floor plans featuring modern amenities like a fitness center, outdoor kitchen, and a shimmering pool with a lake view. Enjoy the comfort of vaulted ceilings, hard floors, and top-notch kitchen appliances—all wrapped in a vibrant community atmosphere with online resident services. Discover your perfect home today and picture yourself living here! Check out our stunning photo gallery now.",
  "property_seo_title_virtualtours": "Virtual Tours | City Harbor Apartments",
  "property_seo_description_virtualtours": "Discover your perfect home at City Harbor in beautiful Melbourne, FL! Explore our spacious one, two, and three-bedroom floor plans designed for comfort and style. Ready to see it for yourself? Take a virtual tour of our community and apartments for rent today!",
  "property_seo_title_interactivemap": "Interactive Map | City Harbor Apartments",
  "property_seo_description_interactivemap": "Discover your perfect home at City Harbor in Melbourne, FL! Explore our diverse floor plans, including one, two, and three-bedroom apartments with stunning lake and courtyard views. Enjoy exceptional amenities like a state-of-the-art fitness center, inviting outdoor kitchen, and refreshing pool. With features like tall ceilings, modern kitchen appliances, and online resident services, you'll love coming home. Use our interactive community map to easily search for your new apartment and view pricing today!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Melbourne, FL",
  "property_seo_description_neighborhood": "Discover the vibrant neighborhood surrounding City Harbor in Melbourne, FL! Explore our one, two, and three-bedroom floor plans while you uncover local favorites, parks, dining spots, and essential points of interest. See what's around our community and embrace the lifestyle you deserve!",
  "property_seo_title_contact": "Contact Us | City Harbor",
  "property_seo_description_contact": "Discover your ideal living space at City Harbor in beautiful Melbourne, FL! Explore our diverse floor plans featuring one, two, and three-bedroom apartments designed for comfort and style. Have questions? Contact our leasing team today for assistance and let us help you find your perfect home!",
  "property_seo_title_faqs": "FAQs | Apartments in Melbourne, FL",
  "property_seo_description_faqs": "Discover everything you need to know about City Harbor in Melbourne, FL! Explore our FAQs page to find insightful answers about our spacious one, two, and three-bedroom floor plans, top-notch amenities like a fitness center, pool, and outdoor kitchen, plus unique features including lake views and vaulted ceilings. Whether you're curious about online resident services or want to learn about our beautiful community, we’ve got you covered. Browse our FAQs and discover why City Harbor is the perfect place to call home!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Melbourne, FL",
  "property_seo_description_reviews": "Discover the vibrant lifestyle at City Harbor in Melbourne, FL! Explore our diverse range of floor plans, including one, two, and three-bedroom apartments featuring modern amenities like a fitness center, outdoor kitchen, and stunning lake views. With online resident services and luxurious touches like tall ceilings and vinyl plank flooring, your new home awaits. Don’t just take our word for it—see what our residents have to say about living in our community!",
  "property_seo_title_applynow": "Apply Now | Apartments in Melbourne, FL",
  "property_seo_description_applynow": "Discover your ideal living space at City Harbor in Melbourne, FL! Choose from our spacious one, two, and three-bedroom floor plans featuring modern amenities like a state-of-the-art fitness center, outdoor kitchen, and a refreshing pool. Enjoy stylish interiors with tall ceilings, vinyl plank and tile backsplashes, plus convenient washer/dryer connections. With online resident services and stunning lake and courtyard views, your dream home awaits. Apply now and lease online today for a vibrant lifestyle at City Harbor!",
  "property_seo_title_residentaccess": "Resident Access | City Harbor",
  "property_seo_description_residentaccess": "\"Log in to City Harbor's Resident Access Portal in Melbourne, FL! Easily pay rent, request maintenance, and manage your apartment living all in one place. Join our vibrant community today!\"",
  "property_seo_title_referafriend": "Refer A Friend | City Harbor",
  "property_seo_description_referafriend": "\"At City Harbor in Melbourne, FL, great friends make great neighbors! Refer a friend to our vibrant apartment community today and enjoy exclusive rewards. Discover your new home together at City Harbor!\"",
  "property_seo_title_scheduletour": "Schedule a Tour | City Harbor",
  "property_seo_description_scheduletour": "Discover your dream home at City Harbor in beautiful Melbourne, FL! Conveniently located near stunning beaches and local attractions, our vibrant apartment community awaits. Schedule a tour today to explore our modern amenities and welcoming atmosphere that make City Harbor the perfect place to call home!",
  "property_seo_title_privacy": "Privacy Policy | City Harbor",
  "property_seo_description_privacy": "Discover the commitment of City Harbor in Melbourne, FL, to protecting your privacy. Our comprehensive Privacy Policy outlines how we safeguard your information while enhancing your living experience. Trust us to keep your data secure—view our privacy policy today!",
  "property_seo_title_accessibility": "Website Accessibility | City Harbor",
  "property_seo_description_accessibility": "Discover City Harbor in Melbourne, FL, where we prioritize digital inclusion for all our residents. Our Accessibility Statement ensures everyone can enjoy our vibrant community. Explore our commitment to accessibility and learn how we support your needs. Join us today!",
  "property_seo_title_sitemap": "Sitemap | City Harbor",
  "property_seo_description_sitemap": "Discover City Harbor, your ideal apartment community in Melbourne, FL! Explore our sitemap to easily navigate through our amenities, floor plans, and services. Find your perfect home today—view our website sitemap!",
  "property_seo_title_thankyou": "Thank You | City Harbor",
  "property_seo_description_thankyou": "\"Thank you for reaching out to City Harbor in Melbourne, FL! We're excited to connect with you and help you find your perfect apartment home. A member of our team will contact you shortly. Stay tuned for more updates!\"",
  "property_seo_title_pets": "Pet Policy | Apartments in Jacksonville, FL\r",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1793651137140",
  "amenities": [
    {
      "id": "ec_e479f3ccbbcbd9f0fb5d50e8",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "source": "generator",
      "external_id": "false",
      "title": "Resort‑Inspired Pool w/ Cabanas",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ad2222999e0cad69e7ba9b74",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "source": "generator",
      "external_id": "false",
      "title": "Outdoor Kitchen w/ Gas Grills",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_04e13a0f08e9e8b496fa4490",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "source": "generator",
      "external_id": "false",
      "title": "Modern Fitness Center w/ Workout Mirror",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e9975999ce5e259ca7d4bd2f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "source": "generator",
      "external_id": "false",
      "title": "Resident Entertainment Room",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_edd4b20b79863d7251b7032f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "source": "generator",
      "external_id": "false",
      "title": "Wi‑Fi Available at Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f4009110e6af3c8a9379cdd6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "source": "generator",
      "external_id": "false",
      "title": "Credit Building Services Powered by RentPlus",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6075df6fe796f3b0f2d0cf21",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "source": "generator",
      "external_id": "false",
      "title": "Concierge Cleaning Services Available by Spruce",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_56d69412fb444a1d352d66bd",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "source": "generator",
      "external_id": "false",
      "title": "Convenient 24/7 Online Resident Services",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2bfcb17914b38855ef666009",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "source": "generator",
      "external_id": "false",
      "title": "American Landmark 360 Resident Program",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_de6b23e7e8d1cdfea9c66e89",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "source": "generator",
      "external_id": "false",
      "title": "Stainless‑Steel Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9a4f05bc9bbedcd810d0bffc",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "source": "generator",
      "external_id": "false",
      "title": "Sleek Granite Countertops",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a58dddd9e30d2a1b478a61d4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "source": "generator",
      "external_id": "false",
      "title": "In‑Home Washer & Dryer*",
      "amount": "false",
      "description": "*In Select Apartments",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b0f65eaf8677dee0e5bc5c9b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "source": "generator",
      "external_id": "false",
      "title": "Decorative Kitchen Backsplash",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ce621b7f5bfcdd9970873163",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "source": "generator",
      "external_id": "false",
      "title": "Wood Style Flooring",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_239b9df35cf7a16a3daa9230",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "source": "generator",
      "external_id": "false",
      "title": "9' Ceilings",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_1cdfeac7-baf5-426f-9d57-76812f741127",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019e898d-2de5-755d-9d59-e9aa31d0d5a8.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a vanity, toilet, and shower with a decorative curtain.",
        "public_id": "019e898d-2de5-755d-9d59-e9aa31d0d5a8",
        "storage_key": "property/5694569974857728/019e898d-2de5-755d-9d59-e9aa31d0d5a8.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Apartment",
      "description": "Experience comfort and style in our beautifully appointed bathrooms, featuring sleek vanities, modern fixtures, and a relaxing shower/tub combo.",
      "link": "",
      "alt_text": "Modern bathroom with a vanity, toilet, and shower with a decorative curtain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_8dd20623-71fc-4560-84a6-b225c7277763",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019e898d-2df3-74b0-9cbc-003235f490da.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool and lake with fountain",
        "public_id": "019e898d-2df3-74b0-9cbc-003235f490da",
        "storage_key": "property/5694569974857728/019e898d-2df3-74b0-9cbc-003235f490da.webp",
        "width": 1858,
        "height": 1238
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our resort-style swimming pool, surrounded by lush landscaping and a serene lake with a picturesque fountain. Perfect for relaxation and unwinding.",
      "link": "",
      "alt_text": "Resort-style swimming pool and lake with fountain",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0faf9598-1221-4a23-85a5-e105987a9a66",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019e898d-237e-7428-85c8-e2219a2f726a.webp",
      "image_media": {
        "alt_text": "Resort-style pool area with lounge chairs and umbrellas",
        "public_id": "019e898d-237e-7428-85c8-e2219a2f726a",
        "storage_key": "property/5694569974857728/019e898d-237e-7428-85c8-e2219a2f726a.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, surrounded by comfortable lounge seating and shaded by large umbrellas. Perfect for relaxing on a sunny day.",
      "link": "",
      "alt_text": "Resort-style pool area with lounge chairs and umbrellas",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_fd59651d-a0e0-4ce8-aa42-bab1b53622c4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019e898d-1fb3-7268-a578-030ee5134f2f.webp",
      "image_media": {
        "alt_text": "Stylish lounge area with coffee bar and view of pool",
        "public_id": "019e898d-1fb3-7268-a578-030ee5134f2f",
        "storage_key": "property/5694569974857728/019e898d-1fb3-7268-a578-030ee5134f2f.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Community",
      "description": "Relax and recharge in our inviting lounge, complete with a coffee bar and stunning views of the resort-style pool.",
      "link": "",
      "alt_text": "Stylish lounge area with coffee bar and view of pool",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_125d49ed-e437-43b7-976b-df7c4c2351df",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019e898d-22e5-72fb-bff5-dd4934ac6223.webp",
      "image_media": {
        "alt_text": "State-of-the-art fitness center with cardio machines, weight machines, and free weights.",
        "public_id": "019e898d-22e5-72fb-bff5-dd4934ac6223",
        "storage_key": "property/5694569974857728/019e898d-22e5-72fb-bff5-dd4934ac6223.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Community",
      "description": "Stay active and energized in our fully-equipped fitness center, featuring treadmills, ellipticals, stationary bikes, and strength training equipment.",
      "link": "",
      "alt_text": "State-of-the-art fitness center with cardio machines, weight machines, and free weights.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_aa2cf004-0b6a-4e4f-820e-9f51a148c6b3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019e898d-1e36-705b-aea0-b2c4a157b0fa.webp",
      "image_media": {
        "alt_text": "Treadmill and elliptical machines in a modern fitness center with mirrored walls.",
        "public_id": "019e898d-1e36-705b-aea0-b2c4a157b0fa",
        "storage_key": "property/5694569974857728/019e898d-1e36-705b-aea0-b2c4a157b0fa.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Community",
      "description": "Stay active in our well-equipped fitness center, featuring cardio machines and free weights.",
      "link": "",
      "alt_text": "Treadmill and elliptical machines in a modern fitness center with mirrored walls.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_06779e9b-09aa-4bdb-ac4a-0277f9eff769",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019e898d-1fa0-716b-a52b-6859b9bec599.webp",
      "image_media": {
        "alt_text": "Living room and kitchen with dining area in an apartment.",
        "public_id": "019e898d-1fa0-716b-a52b-6859b9bec599",
        "storage_key": "property/5694569974857728/019e898d-1fa0-716b-a52b-6859b9bec599.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Apartment",
      "description": "A beautifully furnished apartment featuring a modern living room, a sleek kitchen, and a dining area, perfect for comfortable urban living.",
      "link": "",
      "alt_text": "Living room and kitchen with dining area in an apartment.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_1e0395ce-57f1-4198-b0c5-b41ac2264fb8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019e898d-1bf9-721a-bc7f-0136b119b199.webp",
      "image_media": {
        "alt_text": "Lounge area with a sofa, chairs, coffee table, and arcade game.",
        "public_id": "019e898d-1bf9-721a-bc7f-0136b119b199",
        "storage_key": "property/5694569974857728/019e898d-1bf9-721a-bc7f-0136b119b199.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Community",
      "description": "Relax and unwind in our vibrant community lounge, featuring comfortable seating and a fun arcade game for all to enjoy.",
      "link": "",
      "alt_text": "Lounge area with a sofa, chairs, coffee table, and arcade game.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_eb57d127-cd63-445e-a304-cc0fdafa9194",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019e898d-16ee-74a6-a544-88da3b0afc5d.webp",
      "image_media": {
        "alt_text": "Bedroom with blue walls, queen-size bed with blue and white patterned bedding, and a walk-in closet.",
        "public_id": "019e898d-16ee-74a6-a544-88da3b0afc5d",
        "storage_key": "property/5694569974857728/019e898d-16ee-74a6-a544-88da3b0afc5d.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Apartment",
      "description": "Charming bedroom featuring a comfortable queen-size bed adorned with stylish blue and white linens, complemented by the serene blue walls and a convenient walk-in closet.",
      "link": "",
      "alt_text": "Bedroom with blue walls, queen-size bed with blue and white patterned bedding, and a walk-in closet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_4d2f9cd8-80d1-463f-ad2f-c5a331a48803",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019e898d-135e-731b-ba20-c7869256e400.webp",
      "image_media": {
        "alt_text": "Modern kitchen with granite countertops, stainless steel appliances, and white cabinets.",
        "public_id": "019e898d-135e-731b-ba20-c7869256e400",
        "storage_key": "property/5694569974857728/019e898d-135e-731b-ba20-c7869256e400.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Apartment",
      "description": "Explore the stylish and functional kitchen, featuring sleek granite countertops, stainless steel appliances, and ample white cabinetry.",
      "link": "",
      "alt_text": "Modern kitchen with granite countertops, stainless steel appliances, and white cabinets.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b9c579fc-6ce8-4440-a730-f9754957736c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019e898d-1219-73a5-a992-41528b7ead5e.webp",
      "image_media": {
        "alt_text": "Living room and dining area with open kitchen.",
        "public_id": "019e898d-1219-73a5-a992-41528b7ead5e",
        "storage_key": "property/5694569974857728/019e898d-1219-73a5-a992-41528b7ead5e.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Apartment",
      "description": "Spacious living room and dining area with an open kitchen, perfect for entertaining.",
      "link": "",
      "alt_text": "Living room and dining area with open kitchen.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_27942269-7cc7-4c95-802c-35bef392b11b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019e898d-17ea-72ad-9912-0dab21978fb5.webp",
      "image_media": {
        "alt_text": "Outdoor seating area with gray furniture and umbrellas overlooking a lake.",
        "public_id": "019e898d-17ea-72ad-9912-0dab21978fb5",
        "storage_key": "property/5694569974857728/019e898d-17ea-72ad-9912-0dab21978fb5.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Community",
      "description": "Relax and unwind in our comfortable outdoor seating area, featuring plush gray furniture and shaded umbrellas, perfect for enjoying the serene lake views.",
      "link": "",
      "alt_text": "Outdoor seating area with gray furniture and umbrellas overlooking a lake.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_2bec77b3-12e3-4475-b7d7-bf573b6037d2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019e898c-fb2a-710f-81fd-e38a7a612148.webp",
      "image_media": {
        "alt_text": "A comfortable bedroom with a queen-size bed, blue walls, and modern decor.",
        "public_id": "019e898c-fb2a-710f-81fd-e38a7a612148",
        "storage_key": "property/5694569974857728/019e898c-fb2a-710f-81fd-e38a7a612148.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Relax and unwind in this inviting bedroom, featuring a plush queen-size bed, serene blue walls, and stylish modern furnishings.",
      "link": "",
      "alt_text": "A comfortable bedroom with a queen-size bed, blue walls, and modern decor.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_886bebe6-baaa-4bd6-a1ac-3e2cfad8937c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019e898c-fcb6-706a-8fad-215bed1daaac.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, granite countertops, stainless steel appliances, and wood-look flooring.",
        "public_id": "019e898c-fcb6-706a-8fad-215bed1daaac",
        "storage_key": "property/5694569974857728/019e898c-fcb6-706a-8fad-215bed1daaac.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Apartment",
      "description": "A beautifully designed kitchen featuring white cabinetry, speckled granite countertops, a deep sink, stainless steel appliances, and a window offering natural light.",
      "link": "",
      "alt_text": "Modern kitchen with white cabinets, granite countertops, stainless steel appliances, and wood-look flooring.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_96081457-5049-4e0c-b1f8-1454886f6a83",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019e898c-fcab-729a-a1db-70a94884d2db.webp",
      "image_media": {
        "alt_text": "Outdoor grilling area with seating and swimming pool in the background.",
        "public_id": "019e898c-fcab-729a-a1db-70a94884d2db",
        "storage_key": "property/5694569974857728/019e898c-fcab-729a-a1db-70a94884d2db.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Community",
      "description": "Enjoy al fresco dining with our community grills and seating area, perfect for summer evenings by the pool.",
      "link": "",
      "alt_text": "Outdoor grilling area with seating and swimming pool in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ba2909c9-5261-4f67-a48a-19a6dfac617e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019e898c-fc56-74d1-82eb-3b02f4fcf658.webp",
      "image_media": {
        "alt_text": "Gym with treadmills, weight machines, dumbbells, and workout benches.",
        "public_id": "019e898c-fc56-74d1-82eb-3b02f4fcf658",
        "storage_key": "property/5694569974857728/019e898c-fc56-74d1-82eb-3b02f4fcf658.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Community",
      "description": "State-of-the-art fitness center featuring cardio machines, strength training equipment, free weights, and more for a complete workout.",
      "link": "",
      "alt_text": "Gym with treadmills, weight machines, dumbbells, and workout benches.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_baf0c96d-5d85-4b08-8295-519ff027d1b1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019e898c-fd12-7727-9065-cf8d442d82b1.webp",
      "image_media": {
        "alt_text": "Resort-style pool area with lounge chairs and umbrellas",
        "public_id": "019e898c-fd12-7727-9065-cf8d442d82b1",
        "storage_key": "property/5694569974857728/019e898c-fd12-7727-9065-cf8d442d82b1.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Community",
      "description": "Relax by our stunning resort-style pool, complete with comfortable lounge chairs and shaded umbrellas. Your perfect oasis awaits.",
      "link": "",
      "alt_text": "Resort-style pool area with lounge chairs and umbrellas",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b94b6c21-a2de-407d-96be-fd695bc1c7f2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019e898c-fb54-77be-bdad-b0dd59b8dc4a.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas.",
        "public_id": "019e898c-fb54-77be-bdad-b0dd59b8dc4a",
        "storage_key": "property/5694569974857728/019e898c-fb54-77be-bdad-b0dd59b8dc4a.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, complete with comfortable lounge chairs and umbrellas for ultimate relaxation. A perfect spot for fun and unwinding.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_6bc91d3b-bc88-4bc6-833c-4bf68035e613",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019e898c-fa6d-76de-9ac5-6f2ae69c849a.webp",
      "image_media": {
        "alt_text": "Dining area and kitchen with modern appliances.",
        "public_id": "019e898c-fa6d-76de-9ac5-6f2ae69c849a",
        "storage_key": "property/5694569974857728/019e898c-fa6d-76de-9ac5-6f2ae69c849a.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Apartment",
      "description": "Enjoy meals with friends and family in this stylish dining area, adjacent to a modern, fully-equipped kitchen.",
      "link": "",
      "alt_text": "Dining area and kitchen with modern appliances.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ab14a1b8-5b07-48c9-8c9d-cbc3fa26efef",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019e898c-fc6d-707d-8d70-544cb9dc7868.webp",
      "image_media": {
        "alt_text": "Interior view of a modern apartment complex lobby with seating areas and large windows overlooking a pool.",
        "public_id": "019e898c-fc6d-707d-8d70-544cb9dc7868",
        "storage_key": "property/5694569974857728/019e898c-fc6d-707d-8d70-544cb9dc7868.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Community",
      "description": "Relax in the stylish lobby of our apartment community, featuring comfortable seating and access to the outdoor pool area.",
      "link": "",
      "alt_text": "Interior view of a modern apartment complex lobby with seating areas and large windows overlooking a pool.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_1f522820-1f7e-4eac-9d5e-9373c28ade6d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019e898c-fbec-70d8-8007-3fe300cfa09b.webp",
      "image_media": {
        "alt_text": "Home office with a desk, chair, and window.",
        "public_id": "019e898c-fbec-70d8-8007-3fe300cfa09b",
        "storage_key": "property/5694569974857728/019e898c-fbec-70d8-8007-3fe300cfa09b.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Apartment",
      "description": "Create your perfect workspace in this apartment with a dedicated home office area.",
      "link": "",
      "alt_text": "Home office with a desk, chair, and window.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_1f1a5fb6-1398-4d54-ba45-ea274e35b6a2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019e898c-cfbd-7538-9ca6-ce0e9c6a6500.webp",
      "image_media": {
        "alt_text": "A fenced-in dog park with a blue shade sail, benches, a grill station, and a dog agility tunnel, overlooking a lake with a fountain and a swimming pool in the background.",
        "public_id": "019e898c-cfbd-7538-9ca6-ce0e9c6a6500",
        "storage_key": "property/5694569974857728/019e898c-cfbd-7538-9ca6-ce0e9c6a6500.webp",
        "width": 2186,
        "height": 1456
      },
      "title": "Community",
      "description": "Enjoy our spacious dog park, perfect for your furry friends to play and socialize. This amenity also overlooks the serene lake and resort-style pool area.",
      "link": "",
      "alt_text": "A fenced-in dog park with a blue shade sail, benches, a grill station, and a dog agility tunnel, overlooking a lake with a fountain and a swimming pool in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_dcab7ba6-2401-47cb-adb6-d9163038bb26",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019e898c-dc38-74cd-a451-a4fde9b4ccff.webp",
      "image_media": {
        "alt_text": "Modern living room with a desk, sofa, and TV.",
        "public_id": "019e898c-dc38-74cd-a451-a4fde9b4ccff",
        "storage_key": "property/5694569974857728/019e898c-dc38-74cd-a451-a4fde9b4ccff.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Stylish and comfortable living room featuring a dedicated workspace, a plush sofa, and a wall-mounted television for entertainment.",
      "link": "",
      "alt_text": "Modern living room with a desk, sofa, and TV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_8adfc950-b31c-41ee-9c7f-77e3395f54df",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019e898c-cf4d-712d-9019-9b62aa78544c.webp",
      "image_media": {
        "alt_text": "Modern apartment community leasing office with seating, coffee bar, and reception desk.",
        "public_id": "019e898c-cf4d-712d-9019-9b62aa78544c",
        "storage_key": "property/5694569974857728/019e898c-cf4d-712d-9019-9b62aa78544c.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Community",
      "description": "Welcome to our beautiful apartment community. Enjoy our spacious leasing office, perfect for relaxing or getting work done. Features include comfortable seating, a coffee bar, and a modern reception area.",
      "link": "",
      "alt_text": "Modern apartment community leasing office with seating, coffee bar, and reception desk.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_00345f23-1079-45fc-be49-6d352d6e9a8f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019e898c-cf5e-7099-9a8a-c94b416d9149.webp",
      "image_media": {
        "alt_text": "Modern community lounge with arcade game, seating, and modern decor.",
        "public_id": "019e898c-cf5e-7099-9a8a-c94b416d9149",
        "storage_key": "property/5694569974857728/019e898c-cf5e-7099-9a8a-c94b416d9149.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish community lounge, featuring an arcade game, comfortable seating, and contemporary accents. Perfect for socializing or enjoying some downtime.",
      "link": "",
      "alt_text": "Modern community lounge with arcade game, seating, and modern decor.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_bd179d7e-1483-4e78-a704-7d17e3906127",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019e898c-cf61-7601-894c-7c2ff4b79ccb.webp",
      "image_media": {
        "alt_text": "Dog park with benches and a pond in the background.",
        "public_id": "019e898c-cf61-7601-894c-7c2ff4b79ccb",
        "storage_key": "property/5694569974857728/019e898c-cf61-7601-894c-7c2ff4b79ccb.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Community",
      "description": "Enjoy our spacious dog park, perfect for your furry friends to play and socialize. Relax on the benches while they explore.",
      "link": "",
      "alt_text": "Dog park with benches and a pond in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_fa50b2ea-d532-4172-8e41-ba10bd02a463",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019e898c-d13e-72ce-aa59-f69d060f4f4f.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool area with lounge chairs, umbrellas, and seating.",
        "public_id": "019e898c-d13e-72ce-aa59-f69d060f4f4f",
        "storage_key": "property/5694569974857728/019e898c-d13e-72ce-aa59-f69d060f4f4f.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Community",
      "description": "Relax and unwind by our sparkling outdoor swimming pool, complete with comfortable lounge seating and shaded areas.",
      "link": "",
      "alt_text": "Outdoor swimming pool area with lounge chairs, umbrellas, and seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_6b792a39-a386-4299-8ac6-09dbbf760db7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019e898c-cf56-705d-b668-a03f0ed9c6e1.webp",
      "image_media": {
        "alt_text": "Communal lounge area with seating, a coffee table, and views of the outdoor pool.",
        "public_id": "019e898c-cf56-705d-b668-a03f0ed9c6e1",
        "storage_key": "property/5694569974857728/019e898c-cf56-705d-b668-a03f0ed9c6e1.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish communal lounge, featuring comfortable seating and a scenic view of the sparkling outdoor pool.",
      "link": "",
      "alt_text": "Communal lounge area with seating, a coffee table, and views of the outdoor pool.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_cc88d3af-3929-4deb-a568-11ec96cb11cf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019e898c-cfc2-7022-9476-0ee815a5bae1.webp",
      "image_media": {
        "alt_text": "City Harbor Premier Apartments package locker station",
        "public_id": "019e898c-cfc2-7022-9476-0ee815a5bae1",
        "storage_key": "property/5694569974857728/019e898c-cfc2-7022-9476-0ee815a5bae1.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Community",
      "description": "Convenient package locker station for residents at City Harbor Premier Apartments.",
      "link": "",
      "alt_text": "City Harbor Premier Apartments package locker station",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_3262d42d-76d8-4f70-bfef-1f529610fe76",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019e898c-cfed-70af-acd1-6ab4a37641b5.webp",
      "image_media": {
        "alt_text": "City Harbor Premier Apartments monument sign with landscaping and parking lot.",
        "public_id": "019e898c-cfed-70af-acd1-6ab4a37641b5",
        "storage_key": "property/5694569974857728/019e898c-cfed-70af-acd1-6ab4a37641b5.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Community",
      "description": "Welcome to City Harbor Premier Apartments, featuring a prominent monument sign with the property name, lush landscaping, and convenient parking.",
      "link": "",
      "alt_text": "City Harbor Premier Apartments monument sign with landscaping and parking lot.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d26a4224-4428-4e19-b7ec-ad149cd8a8c2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019e898c-cfe7-74f9-94d4-30c89e4084f5.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with manicured lawns and pathways.",
        "public_id": "019e898c-cfe7-74f9-94d4-30c89e4084f5",
        "storage_key": "property/5694569974857728/019e898c-cfe7-74f9-94d4-30c89e4084f5.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Community",
      "description": "Beautifully landscaped grounds with lush green lawns and well-maintained hedges, leading to the apartment buildings.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with manicured lawns and pathways.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_04c58458-73f9-434a-9c33-a4ba32bacf2b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019e898c-c287-7210-9f1d-332dd775decc.webp",
      "image_media": {
        "alt_text": "Closet with white robe, slippers, and blue storage baskets.",
        "public_id": "019e898c-c287-7210-9f1d-332dd775decc",
        "storage_key": "property/5694569974857728/019e898c-c287-7210-9f1d-332dd775decc.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Apartment",
      "description": "Spacious closet with organized shelving, perfect for storing your belongings in style.",
      "link": "",
      "alt_text": "Closet with white robe, slippers, and blue storage baskets.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "ec_883cd8793e25eaa482b74864",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "source": "generator",
      "poi_name": "Frigate's Waterfront Bar & Grill - Melbourne",
      "poi_type": "Restaurants",
      "poi_address": "1120 N Harbor City Blvd, Melbourne, FL 32935, USA",
      "poi_short_description": "Airy waterfront spot offering sushi, burgers, fish tacos & salads, plus TV sports.",
      "poi_long_description": "Airy waterfront spot offering sushi, burgers, fish tacos & salads, plus TV sports.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f150e-6d10-7094-af3c-b4099be1f7de.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-6d10-7094-af3c-b4099be1f7de",
        "storage_key": "property/5694569974857728/019f150e-6d10-7094-af3c-b4099be1f7de.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.frigateswaterfront.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4411931920132686300&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "frigates-waterfront-bar--grill---melbourne",
      "poi_latitude": "28.1253571",
      "poi_longitude": "-80.630853",
      "poi_miles_from_property": "3.3 mi",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 321-306-3800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f150f-37e3-72b9-a07f-a6c52c7361c1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-37e3-72b9-a07f-a6c52c7361c1",
        "storage_key": "property/5694569974857728/019f150f-37e3-72b9-a07f-a6c52c7361c1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJtUaBvV4R3ogR3EG3uLRUOj0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar_and_grill"
    },
    {
      "id": "ec_bdc1187d475cf1b579674b56",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "source": "generator",
      "poi_name": "Bacco Wine Cafe",
      "poi_type": "Restaurants",
      "poi_address": "4100 N Wickham Rd Apt 108, Melbourne, FL 32935, USA",
      "poi_short_description": "Relaxed strip-mall trattoria serves modern Italian cuisine in cozy, contemporary quarters.",
      "poi_long_description": "Relaxed strip-mall trattoria serves modern Italian cuisine in cozy, contemporary quarters.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f1510-be57-764a-bcd4-0d5ac2b727a4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1510-be57-764a-bcd4-0d5ac2b727a4",
        "storage_key": "property/5694569974857728/019f1510-be57-764a-bcd4-0d5ac2b727a4.webp",
        "width": 1280,
        "height": 1227
      },
      "poi_business_url": "http://www.baccowinecafe.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17538122501736519788&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bacco-wine-cafe",
      "poi_latitude": "28.1730172",
      "poi_longitude": "-80.6737139",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 321-259-3456",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f150f-3834-73b2-b0fa-70015c12271f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-3834-73b2-b0fa-70015c12271f",
        "storage_key": "property/5694569974857728/019f150f-3834-73b2-b0fa-70015c12271f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7ZFuW3kF3ogRbFhKj37tY_M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "ec_f4bf82d495279e56ca9b45f8",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "source": "generator",
      "poi_name": "Meg O’Malley's Restaurant & Irish Pub",
      "poi_type": "Restaurants",
      "poi_address": "812 E New Haven Ave, Melbourne, FL 32901, USA",
      "poi_short_description": "Irish pub, eatery and bar providing staples like fish and chips and shepherd's pie as well as a full bar.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f150e-5a50-710b-b4f0-b5c768a818e3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-5a50-710b-b4f0-b5c768a818e3",
        "storage_key": "property/5694569974857728/019f150e-5a50-710b-b4f0-b5c768a818e3.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.megomalleys.com/?y_source=1_MjI1NzMwOTktNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=9635962277486891816&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "meg-omalleys-restaurant--irish-pub",
      "poi_latitude": "28.0787286",
      "poi_longitude": "-80.6072509",
      "poi_miles_from_property": "7.2 mi",
      "poi_walking_minutes": "2 hours 39 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 321-952-5510",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f150f-3834-73b2-b0fa-70015c12271f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-3834-73b2-b0fa-70015c12271f",
        "storage_key": "property/5694569974857728/019f150f-3834-73b2-b0fa-70015c12271f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2QdwWowR3ogRKJOrSqPQuYU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_b615af4ec4a14170219affe4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "source": "generator",
      "poi_name": "Moon River Cafe & Curiosities",
      "poi_type": "Restaurants",
      "poi_address": "728 E New Haven Ave, Melbourne, FL 32901, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f1510-c189-733d-85c8-011663529df5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1510-c189-733d-85c8-011663529df5",
        "storage_key": "property/5694569974857728/019f1510-c189-733d-85c8-011663529df5.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.themoonrivercafe.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10857117253386916749&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "moon-river-cafe--curiosities",
      "poi_latitude": "28.078719",
      "poi_longitude": "-80.6079518",
      "poi_miles_from_property": "7.1 mi",
      "poi_walking_minutes": "2 hours 38 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f1511-0199-7615-a8f5-dce2b2966857.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1511-0199-7615-a8f5-dce2b2966857",
        "storage_key": "property/5694569974857728/019f1511-0199-7615-a8f5-dce2b2966857.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJVeIf_RUR3ogRjVPkVJ46rJY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cafe"
    },
    {
      "id": "ec_6660002ccb7ff47a0ae9d5fb",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "source": "generator",
      "poi_name": "IHOP",
      "poi_type": "Restaurants",
      "poi_address": "2447 N Wickham Rd Unit #144, Melbourne, FL 32935, USA",
      "poi_short_description": "Long-standing chain serving a wide variety of pancakes & other American breakfast & diner fare.",
      "poi_long_description": "Long-standing chain serving a wide variety of pancakes & other American breakfast & diner fare.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f1510-c49f-72dd-8238-468261728fb6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1510-c49f-72dd-8238-468261728fb6",
        "storage_key": "property/5694569974857728/019f1510-c49f-72dd-8238-468261728fb6.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://restaurants.ihop.com/en-us/fl/melbourne/breakfast-2447-n.-wickham-road-144-360258?utm_source=google&utm_medium=organic&utm_campaign=google_my_business&utm_term=360258&utm_content=website",
      "poi_directions_map_url": "https://maps.google.com/?cid=14640386937514889037&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ihop",
      "poi_latitude": "28.1453464",
      "poi_longitude": "-80.67124489999999",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 321-312-0022",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f150f-3834-73b2-b0fa-70015c12271f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-3834-73b2-b0fa-70015c12271f",
        "storage_key": "property/5694569974857728/019f150f-3834-73b2-b0fa-70015c12271f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJH8C6JjAP3ogRTQ_YAFoaLcs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "breakfast_restaurant"
    },
    {
      "id": "ec_9bd706bf282e8b3d76ff4657",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "source": "generator",
      "poi_name": "Sarno Restaurant & Pizzeria",
      "poi_type": "Restaurants",
      "poi_address": "2110 Sarno Rd, Melbourne, FL 32935, USA",
      "poi_short_description": "Pizza by the slice or whole pie, traditional Italian entrees & American breakfasts in informal digs.",
      "poi_long_description": "Pizza by the slice or whole pie, traditional Italian entrees & American breakfasts in informal digs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f1510-c113-70a9-83a2-5da402f29274.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1510-c113-70a9-83a2-5da402f29274",
        "storage_key": "property/5694569974857728/019f1510-c113-70a9-83a2-5da402f29274.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.sarnorestaurantandpizzeria.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2010655095643410514&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sarno-restaurant--pizzeria",
      "poi_latitude": "28.1231059",
      "poi_longitude": "-80.6559934",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 321-254-6400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f150f-3834-73b2-b0fa-70015c12271f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-3834-73b2-b0fa-70015c12271f",
        "storage_key": "property/5694569974857728/019f150f-3834-73b2-b0fa-70015c12271f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJsVX0QrUP3ogRUpCnFShI5xs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "ec_ce5b4a88098eccdee2cca27a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "source": "generator",
      "poi_name": "Yellow Dog Cafe",
      "poi_type": "Restaurants",
      "poi_address": "905 US-1, Malabar, FL 32950, USA",
      "poi_short_description": "Refined American fare in a dynamic riverfront eatery with several wood-dominated dining rooms.",
      "poi_long_description": "Refined American fare in a dynamic riverfront eatery with several wood-dominated dining rooms.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f1510-c3e6-7529-b5f4-d3c930b69249.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1510-c3e6-7529-b5f4-d3c930b69249",
        "storage_key": "property/5694569974857728/019f1510-c3e6-7529-b5f4-d3c930b69249.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.yellowdogcafe.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5830508589359481034&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "yellow-dog-cafe",
      "poi_latitude": "28.0122833",
      "poi_longitude": "-80.5672475",
      "poi_miles_from_property": "12.3 mi",
      "poi_walking_minutes": "4 hours 30 mins",
      "poi_biking_minutes": "1 hour 25 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 321-956-3334",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f150f-3834-73b2-b0fa-70015c12271f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-3834-73b2-b0fa-70015c12271f",
        "storage_key": "property/5694569974857728/019f150f-3834-73b2-b0fa-70015c12271f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5y-FIg0T3ogRysCisKsg6lA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_84a76d8c13c54efc97547391",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "source": "generator",
      "poi_name": "Indian River Coffee Co., Inc.",
      "poi_type": "Restaurants",
      "poi_address": "Sarno Business Complex, 2112A Sarno Rd, Melbourne, FL 32935, USA",
      "poi_short_description": "Cafe that roasts on-site, offering espresso drinks & pastry, with seating & a drive-thru window.",
      "poi_long_description": "Cafe that roasts on-site, offering espresso drinks & pastry, with seating & a drive-thru window.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f1510-bd6f-7005-88d7-e5612345dc39.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1510-bd6f-7005-88d7-e5612345dc39",
        "storage_key": "property/5694569974857728/019f1510-bd6f-7005-88d7-e5612345dc39.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://indianrivercoffee.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18291053542128615643&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "indian-river-coffee-co-inc",
      "poi_latitude": "28.1220213",
      "poi_longitude": "-80.65612360000002",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 321-259-8005",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f1511-0199-7615-a8f5-dce2b2966857.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1511-0199-7615-a8f5-dce2b2966857",
        "storage_key": "property/5694569974857728/019f1511-0199-7615-a8f5-dce2b2966857.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJXQfRQbUP3ogR2wA6Ukng1v0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "ec_a43570371b6596f2df15e58c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "source": "generator",
      "poi_name": "Bubbakoo's Burritos",
      "poi_type": "Restaurants",
      "poi_address": "3600 N Wickham Rd, Melbourne, FL 32935, USA",
      "poi_short_description": "Casual eatery featuring burritos (including steak and chicken) and burrito bowls, alongside tacos and quesadillas, plus steak and shrimp dishes.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f1510-bd57-7328-bfed-74c00747f32b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1510-bd57-7328-bfed-74c00747f32b",
        "storage_key": "property/5694569974857728/019f1510-bd57-7328-bfed-74c00747f32b.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://locations.bubbakoos.com/locations/fl/3600-n-wickham-road",
      "poi_directions_map_url": "https://maps.google.com/?cid=942727085826772614&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bubbakoos-burritos",
      "poi_latitude": "28.1641049",
      "poi_longitude": "-80.67243979999999",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 321-622-6950",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f150f-3834-73b2-b0fa-70015c12271f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-3834-73b2-b0fa-70015c12271f",
        "storage_key": "property/5694569974857728/019f150f-3834-73b2-b0fa-70015c12271f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJL_akFYkP3ogRhg7YLko9FQ0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "ec_ade93a6502e68ad00cfebf95",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "source": "generator",
      "poi_name": "Straight Outta Philly Melbourne Wickham",
      "poi_type": "Restaurants",
      "poi_address": "4250 N Wickham Rd, Melbourne, FL 32935, USA",
      "poi_short_description": "Philadelphia-themed pizzeria serving up cheesesteaks, gyros, strombolis, and pizza in a casual setting.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f1510-bd5e-7098-811f-56b19cbfe259.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1510-bd5e-7098-811f-56b19cbfe259",
        "storage_key": "property/5694569974857728/019f1510-bd5e-7098-811f-56b19cbfe259.webp",
        "width": 1238,
        "height": 826
      },
      "poi_business_url": "https://www.orderstraightouttaphilly.com/?utm_source=gbp",
      "poi_directions_map_url": "https://maps.google.com/?cid=2761342134806218932&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "straight-outta-philly-melbourne-wickham",
      "poi_latitude": "28.1767579",
      "poi_longitude": "-80.6724847",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 321-735-4872",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f150f-3834-73b2-b0fa-70015c12271f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-3834-73b2-b0fa-70015c12271f",
        "storage_key": "property/5694569974857728/019f150f-3834-73b2-b0fa-70015c12271f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ71knmKMD3ogRtIhxmApCUiY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "ec_ab8a1438eddac82e865f2b39",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "source": "generator",
      "poi_name": "Umami Restaurant and Sushi Bar Indian Harbour Beach",
      "poi_type": "Restaurants",
      "poi_address": "971 E Eau Gallie Blvd F, Melbourne, FL 32937, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f1510-c128-744a-95b1-8ccc107580da.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1510-c128-744a-95b1-8ccc107580da",
        "storage_key": "property/5694569974857728/019f1510-c128-744a-95b1-8ccc107580da.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://myumamisushi.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8847530755109951173&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "umami-restaurant-and-sushi-bar-indian-harbour-beach",
      "poi_latitude": "28.137157",
      "poi_longitude": "-80.584062",
      "poi_miles_from_property": "5.9 mi",
      "poi_walking_minutes": "2 hours 10 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 321-777-2988",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f150f-3834-73b2-b0fa-70015c12271f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-3834-73b2-b0fa-70015c12271f",
        "storage_key": "property/5694569974857728/019f150f-3834-73b2-b0fa-70015c12271f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJFzvw-d4R3ogRxRasdVi-yHo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sushi_restaurant"
    },
    {
      "id": "ec_7900a59a5d7cd86e02477ae3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "source": "generator",
      "poi_name": "Bizzarro Pizza",
      "poi_type": "Restaurants",
      "poi_address": "635 S Wickham Rd, West Melbourne, FL 32904, USA",
      "poi_short_description": "A no-fuss option for straight-up classic & specialty pizzas, plus salads & simple pasta dishes.",
      "poi_long_description": "A no-fuss option for straight-up classic & specialty pizzas, plus salads & simple pasta dishes.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f1510-c5cd-74fa-a815-f08b86c50582.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1510-c5cd-74fa-a815-f08b86c50582",
        "storage_key": "property/5694569974857728/019f1510-c5cd-74fa-a815-f08b86c50582.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "http://www.bizzarropizzafl.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12282911431345185879&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bizzarro-pizza",
      "poi_latitude": "28.0966478",
      "poi_longitude": "-80.6721164",
      "poi_miles_from_property": "3.9 mi",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 321-953-0334",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f150f-3834-73b2-b0fa-70015c12271f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-3834-73b2-b0fa-70015c12271f",
        "storage_key": "property/5694569974857728/019f150f-3834-73b2-b0fa-70015c12271f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJy5eCI2EO3ogRVyTqgN6qdao",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "ec_8b281982e2250960e7b26deb",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "source": "generator",
      "poi_name": "ALDI",
      "poi_type": "Shopping & Retail",
      "poi_address": "1400 N Wickham Rd, Melbourne, FL 32935, USA",
      "poi_short_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_long_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f1510-ca7c-7236-88f2-656fc26eafe1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1510-ca7c-7236-88f2-656fc26eafe1",
        "storage_key": "property/5694569974857728/019f1510-ca7c-7236-88f2-656fc26eafe1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://info.aldi.us/stores/l/fl/melbourne/1400-n-wickham-rd/fk49",
      "poi_directions_map_url": "https://maps.google.com/?cid=4399058140791740295&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "aldi",
      "poi_latitude": "28.1302014",
      "poi_longitude": "-80.6730518",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 855-955-2534",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f150f-37e6-767e-a95b-dc3c4edfbc6e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-37e6-767e-a95b-dc3c4edfbc6e",
        "storage_key": "property/5694569974857728/019f150f-37e6-767e-a95b-dc3c4edfbc6e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6wFgNqkP3ogRh5cuZBKYDD0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "ec_0494f8f9d8ca115ac1f695fa",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "source": "generator",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "1000 N Wickham Rd, Melbourne, FL 32935, USA",
      "poi_short_description": "Grocery chain selling everything from produce and meats, to electronics, toys and apparel.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f1510-c82b-70df-94ea-b377bebf333e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1510-c82b-70df-94ea-b377bebf333e",
        "storage_key": "property/5694569974857728/019f1510-c82b-70df-94ea-b377bebf333e.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/1702-melbourne-fl/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=17437529999130243056&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "28.1228905",
      "poi_longitude": "-80.6744786",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 321-242-1601",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f150f-3837-7012-a605-c0255b9aa378.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-3837-7012-a605-c0255b9aa378",
        "storage_key": "property/5694569974857728/019f150f-3837-7012-a605-c0255b9aa378.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJS253IqsP3ogR8C9gbiWN_vE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "ec_5b675e5d3aee12c3bc5ef18f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "source": "generator",
      "poi_name": "Publix Super Market at Lake Washington Crossing",
      "poi_type": "Shopping & Retail",
      "poi_address": "3200 Lake Washington Rd, Melbourne, FL 32934, USA",
      "poi_short_description": "Supermarket chain with a wide selection of groceries, plus deli & bakery departments.",
      "poi_long_description": "Supermarket chain with a wide selection of groceries, plus deli & bakery departments.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f1510-c8f0-708f-a060-9b06b73bd7d8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1510-c8f0-708f-a060-9b06b73bd7d8",
        "storage_key": "property/5694569974857728/019f1510-c8f0-708f-a060-9b06b73bd7d8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.publix.com/?utm_medium=maps&utm_source=google&utm_content=psm_google_override",
      "poi_directions_map_url": "https://maps.google.com/?cid=6021276615249535161&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "publix-super-market-at-lake-washington-crossing",
      "poi_latitude": "28.1475762",
      "poi_longitude": "-80.67439279999999",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 321-426-2208",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f150f-37e6-767e-a95b-dc3c4edfbc6e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-37e6-767e-a95b-dc3c4edfbc6e",
        "storage_key": "property/5694569974857728/019f150f-37e6-767e-a95b-dc3c4edfbc6e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJwj5qp8P3ogRuaBQ8i3fj1M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "ec_d86c7d451da68a4b7c9a3170",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "source": "generator",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Shopping & Retail",
      "poi_address": "3050 N Wickham Rd, Melbourne, FL 32935, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f1510-c879-701d-a99d-9078119628a3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1510-c879-701d-a99d-9078119628a3",
        "storage_key": "property/5694569974857728/019f1510-c879-701d-a99d-9078119628a3.webp",
        "width": 1100,
        "height": 743
      },
      "poi_business_url": "https://www.cvs.com/store-locator/melbourne-fl-pharmacies/3050-n-wickham-rd-melbourne-fl-32935/storeid=4998?WT.mc_id=LS_GOOGLE_RX_4998",
      "poi_directions_map_url": "https://maps.google.com/?cid=16815560252287242911&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "28.1570788",
      "poi_longitude": "-80.6726991",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 321-751-7524",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f1511-019c-77ae-9ec5-30c0803b320b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1511-019c-77ae-9ec5-30c0803b320b",
        "storage_key": "property/5694569974857728/019f1511-019c-77ae-9ec5-30c0803b320b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJf6A7RoMP3ogRn1LC8PTeXOk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_d360fcbacb83d129558fa7fe",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "source": "generator",
      "poi_name": "Walgreens",
      "poi_type": "Shopping & Retail",
      "poi_address": "4020 N Wickham Rd, Melbourne, FL 32935, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f1510-c9bc-71be-8bb7-0a902a599176.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1510-c9bc-71be-8bb7-0a902a599176",
        "storage_key": "property/5694569974857728/019f1510-c9bc-71be-8bb7-0a902a599176.webp",
        "width": 1280,
        "height": 598
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-4020+n+wickham+rd-melbourne-fl-32935/id=4259",
      "poi_directions_map_url": "https://maps.google.com/?cid=8472087117228719284&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "28.172507",
      "poi_longitude": "-80.672645",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 321-254-7803",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f150f-381c-76c8-a538-0b9e5750637a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-381c-76c8-a538-0b9e5750637a",
        "storage_key": "property/5694569974857728/019f150f-381c-76c8-a538-0b9e5750637a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJbz8nUnkF3ogRtLyUmFjmknU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "ec_151c1ac5a8efc223f021432f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "source": "generator",
      "poi_name": "Dollar General",
      "poi_type": "Shopping & Retail",
      "poi_address": "2447 N Wickham Rd Ste 130, Melbourne, FL 32935, USA",
      "poi_short_description": "Bargain retail chain selling a range of household goods, groceries, beauty products & more.",
      "poi_long_description": "Bargain retail chain selling a range of household goods, groceries, beauty products & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f1510-caec-725d-aeba-f0b5008ccfea.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1510-caec-725d-aeba-f0b5008ccfea",
        "storage_key": "property/5694569974857728/019f1510-caec-725d-aeba-f0b5008ccfea.webp",
        "width": 480,
        "height": 720
      },
      "poi_business_url": "https://www.dollargeneral.com/store-directory/fl/melbourne/4037",
      "poi_directions_map_url": "https://maps.google.com/?cid=16542729251379348138&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dollar-general",
      "poi_latitude": "28.1453665",
      "poi_longitude": "-80.6696359",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 321-952-8097",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f150f-3837-7012-a605-c0255b9aa378.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-3837-7012-a605-c0255b9aa378",
        "storage_key": "property/5694569974857728/019f150f-3837-7012-a605-c0255b9aa378.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJoRlevpgP3ogRqgLuY5uUk-U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "discount_store"
    },
    {
      "id": "ec_6809ec4ebc39d12a7fd4838a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "source": "generator",
      "poi_name": "Circle K",
      "poi_type": "Shopping & Retail",
      "poi_address": "2455 N Wickham Rd, Melbourne, FL 32935, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f1510-cc22-7332-ba5c-d15d9d65f372.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1510-cc22-7332-ba5c-d15d9d65f372",
        "storage_key": "property/5694569974857728/019f1510-cc22-7332-ba5c-d15d9d65f372.webp",
        "width": 1280,
        "height": 591
      },
      "poi_business_url": "https://www.circlek.com/store-locator/US/melbourne/2455-n-wickham-rd/2726087?utm_source=google&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=3140912976360572555&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "circle-k",
      "poi_latitude": "28.1470866",
      "poi_longitude": "-80.6712649",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 321-254-6648",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f1511-019a-753d-a60e-ba3b41c20096.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1511-019a-753d-a60e-ba3b41c20096",
        "storage_key": "property/5694569974857728/019f1511-019a-753d-a60e-ba3b41c20096.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJOfO_LZ8P3ogRiwZj8rXDlis",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "ec_cb7777e3f95071756d302e46",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "source": "generator",
      "poi_name": "Dollar Tree",
      "poi_type": "Shopping & Retail",
      "poi_address": "1270 N Wickham Rd, Melbourne, FL 32935, USA",
      "poi_short_description": "Chain offering a mix of household items, beauty products, food & more at discount prices.",
      "poi_long_description": "Chain offering a mix of household items, beauty products, food & more at discount prices.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f1510-cbdc-7638-ba3b-5ba0366530ec.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1510-cbdc-7638-ba3b-5ba0366530ec",
        "storage_key": "property/5694569974857728/019f1510-cbdc-7638-ba3b-5ba0366530ec.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://locations.dollartree.com/fl/melbourne/1270-n-wickham-rd?utm_source=google&utm_medium=organic&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=11539038986303553430&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dollar-tree",
      "poi_latitude": "28.1261332",
      "poi_longitude": "-80.6737838",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 321-312-0020",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f150f-3837-7012-a605-c0255b9aa378.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-3837-7012-a605-c0255b9aa378",
        "storage_key": "property/5694569974857728/019f150f-3837-7012-a605-c0255b9aa378.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJJ9Ok0KsP3ogRlr8BVNLmIqA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "discount_store"
    },
    {
      "id": "ec_31637d8d89d02fc0dfa3d080",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "source": "generator",
      "poi_name": "Target",
      "poi_type": "Shopping & Retail",
      "poi_address": "2750 W New Haven Ave, Melbourne Village, FL 32904, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f1510-cd8e-7381-b2fa-1578c915b6eb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1510-cd8e-7381-b2fa-1578c915b6eb",
        "storage_key": "property/5694569974857728/019f1510-cd8e-7381-b2fa-1578c915b6eb.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.target.com/sl/melbourne/689",
      "poi_directions_map_url": "https://maps.google.com/?cid=14772651877834583035&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "target",
      "poi_latitude": "28.0801753",
      "poi_longitude": "-80.6656036",
      "poi_miles_from_property": "5.4 mi",
      "poi_walking_minutes": "2 hours 0 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 321-727-3238",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f150f-3837-7012-a605-c0255b9aa378.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-3837-7012-a605-c0255b9aa378",
        "storage_key": "property/5694569974857728/019f150f-3837-7012-a605-c0255b9aa378.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJHwt-XXcO3ogR-2vWMJ0AA80",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "ec_ec0d3da5ac4d26790194b443",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "source": "generator",
      "poi_name": "West Melbourne Ace Hardware",
      "poi_type": "Shopping & Retail",
      "poi_address": "3221 W New Haven Ave, Melbourne, FL 32904, USA",
      "poi_short_description": "Hardware store stocking household tools, garden supplies, home decor & more.",
      "poi_long_description": "Hardware store stocking household tools, garden supplies, home decor & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f1510-cda6-745c-8559-bf2dad19f845.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1510-cda6-745c-8559-bf2dad19f845",
        "storage_key": "property/5694569974857728/019f1510-cda6-745c-8559-bf2dad19f845.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.acehardware.com/store-details/04822?utm_source=google&utm_medium=local&utm_campaign=localmaps&utm_content=04822",
      "poi_directions_map_url": "https://maps.google.com/?cid=18181097062828119324&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "west-melbourne-ace-hardware",
      "poi_latitude": "28.078362",
      "poi_longitude": "-80.67500299999999",
      "poi_miles_from_property": "5.3 mi",
      "poi_walking_minutes": "1 hour 58 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 321-724-6510",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f150f-3837-7012-a605-c0255b9aa378.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-3837-7012-a605-c0255b9aa378",
        "storage_key": "property/5694569974857728/019f150f-3837-7012-a605-c0255b9aa378.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJJ-ecTX4O3ogRHJXEeHM7UPw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hardware_store"
    },
    {
      "id": "ec_d7d331c237254498f3a513b5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "source": "generator",
      "poi_name": "Sabal Elementary School",
      "poi_type": "Education",
      "poi_address": "1401 N Wickham Rd, Melbourne, FL 32935, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f1510-cedc-7639-af68-e038f5bf5020.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1510-cedc-7639-af68-e038f5bf5020",
        "storage_key": "property/5694569974857728/019f1510-cedc-7639-af68-e038f5bf5020.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.brevardschools.org/sabales",
      "poi_directions_map_url": "https://maps.google.com/?cid=4701177816725742907&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sabal-elementary-school",
      "poi_latitude": "28.1306173",
      "poi_longitude": "-80.6709686",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 321-254-7261",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f150f-37ef-74de-abb7-2b8044b418ed.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-37ef-74de-abb7-2b8044b418ed",
        "storage_key": "property/5694569974857728/019f150f-37ef-74de-abb7-2b8044b418ed.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJJb9IJ68P3ogRO2Xi_1DwPUE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_25f01b4da6d1f3ef97e0bd8e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "source": "generator",
      "poi_name": "Croton Elementary School",
      "poi_type": "Education",
      "poi_address": "1449 Croton Rd, Melbourne, FL 32935, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.brevardschools.org/CrotonES",
      "poi_directions_map_url": "https://maps.google.com/?cid=11517865843904027076&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "croton-elementary-school",
      "poi_latitude": "28.1298269",
      "poi_longitude": "-80.6540212",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 321-259-3818",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f150f-37ef-74de-abb7-2b8044b418ed.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-37ef-74de-abb7-2b8044b418ed",
        "storage_key": "property/5694569974857728/019f150f-37ef-74de-abb7-2b8044b418ed.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ6y4T4LcP3ogRxBmB9PWt158",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_a7c09b44b2e4b9e287efd413",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "source": "generator",
      "poi_name": "Lyndon B. Johnson Middle School",
      "poi_type": "Education",
      "poi_address": "2155 Croton Rd, Melbourne, FL 32935, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.brevardschools.org/JohnsonMS",
      "poi_directions_map_url": "https://maps.google.com/?cid=10483086605401005069&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lyndon-b-johnson-middle-school",
      "poi_latitude": "28.1423159",
      "poi_longitude": "-80.65384790000002",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 321-242-6430",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f150f-37ef-74de-abb7-2b8044b418ed.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-37ef-74de-abb7-2b8044b418ed",
        "storage_key": "property/5694569974857728/019f150f-37ef-74de-abb7-2b8044b418ed.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJEULBE8AP3ogRDRyV0Llne5E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_8a390258adbb23be7f347d25",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "source": "generator",
      "poi_name": "Eau Gallie High School",
      "poi_type": "Education",
      "poi_address": "1400 Commodore Blvd, Melbourne, FL 32935, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f1510-d1e7-70f6-9f48-37fb144cd31d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1510-d1e7-70f6-9f48-37fb144cd31d",
        "storage_key": "property/5694569974857728/019f1510-d1e7-70f6-9f48-37fb144cd31d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.brevardschools.org/EauGallieHS",
      "poi_directions_map_url": "https://maps.google.com/?cid=14111772569090900875&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "eau-gallie-high-school",
      "poi_latitude": "28.1309297",
      "poi_longitude": "-80.6477342",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 321-242-6400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f150f-37ef-74de-abb7-2b8044b418ed.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-37ef-74de-abb7-2b8044b418ed",
        "storage_key": "property/5694569974857728/019f150f-37ef-74de-abb7-2b8044b418ed.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJN-TRVsQP3ogRi8PDW2IW18M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "ec_136630ebcc238e1a65731909",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "source": "generator",
      "poi_name": "Eastern Florida State College - Melbourne Campus",
      "poi_type": "Education",
      "poi_address": "3865 N Wickham Rd, Melbourne, FL 32935, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f150e-77a7-7251-bea4-77ea21aef907.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-77a7-7251-bea4-77ea21aef907",
        "storage_key": "property/5694569974857728/019f150e-77a7-7251-bea4-77ea21aef907.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.easternflorida.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6372378352007033922&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "eastern-florida-state-college---melbourne-campus",
      "poi_latitude": "28.169954",
      "poi_longitude": "-80.6708733",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 321-632-1111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f150f-37ef-74de-abb7-2b8044b418ed.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-37ef-74de-abb7-2b8044b418ed",
        "storage_key": "property/5694569974857728/019f150f-37ef-74de-abb7-2b8044b418ed.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJc0YBfn4F3ogRQrTETVk8b1g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_65ffa950ad1dc2a5f3d0db52",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "source": "generator",
      "poi_name": "Apollo Preschool",
      "poi_type": "Education",
      "poi_address": "155 Babcock St, Melbourne, FL 32935, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f1510-d245-71bd-941d-d81e8f6b58c1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1510-d245-71bd-941d-d81e8f6b58c1",
        "storage_key": "property/5694569974857728/019f1510-d245-71bd-941d-d81e8f6b58c1.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://apollopreschool.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17575016518837111282&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "apollo-preschool",
      "poi_latitude": "28.1096662",
      "poi_longitude": "-80.6213345",
      "poi_miles_from_property": "4.7 mi",
      "poi_walking_minutes": "1 hour 44 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 321-752-1161",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f150f-37ef-74de-abb7-2b8044b418ed.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-37ef-74de-abb7-2b8044b418ed",
        "storage_key": "property/5694569974857728/019f150f-37ef-74de-abb7-2b8044b418ed.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ6YJR1tER3ogR8onoTmgA5_M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "ec_e6755e0cc668b4401fe74b53",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "source": "generator",
      "poi_name": "Wickham KinderCare",
      "poi_type": "Education",
      "poi_address": "2220 N Wickham Rd, Melbourne, FL 32935, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f1510-d244-76ca-a983-d79c7231ed1f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1510-d244-76ca-a983-d79c7231ed1f",
        "storage_key": "property/5694569974857728/019f1510-d244-76ca-a983-d79c7231ed1f.webp",
        "width": 1000,
        "height": 750
      },
      "poi_business_url": "https://www.kindercare.com/our-centers/melbourne/fl/300792?utm_campaign=kc-lg&utm_source=yext&utm_medium=pro&utm_keyword=&utm_platform=&utm_matchtype=&utm_adgroupid=&utm_content=gmb&y_source=1_NTA3MzU2LTcxNS1sb2NhdGlvbi53ZWJzaXRl",
      "poi_directions_map_url": "https://maps.google.com/?cid=12992386899976652737&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wickham-kindercare",
      "poi_latitude": "28.1432311",
      "poi_longitude": "-80.67236489999999",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 321-254-4029",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f150f-37ef-74de-abb7-2b8044b418ed.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-37ef-74de-abb7-2b8044b418ed",
        "storage_key": "property/5694569974857728/019f150f-37ef-74de-abb7-2b8044b418ed.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJKU469KEP3ogRwQeMhQw7TrQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "ec_5a361d33e41934398c6ef3f2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "source": "generator",
      "poi_name": "Ascension Catholic School",
      "poi_type": "Education",
      "poi_address": "2950 N Harbor City Blvd, Melbourne, FL 32935, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.ascensioncatholicsch.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14130217073885369819&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ascension-catholic-school",
      "poi_latitude": "28.156092",
      "poi_longitude": "-80.64210659999999",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 321-254-1595",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f150f-37ef-74de-abb7-2b8044b418ed.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-37ef-74de-abb7-2b8044b418ed",
        "storage_key": "property/5694569974857728/019f150f-37ef-74de-abb7-2b8044b418ed.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJk5WzTOUP3ogR29UYSJCdGMQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_3e2888a07faf569089cc66a2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "source": "generator",
      "poi_name": "Melbourne Central Catholic High School",
      "poi_type": "Education",
      "poi_address": "154 E Florida Ave, Melbourne, FL 32901, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f1510-d384-77d6-9ea3-2ad68818503f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1510-d384-77d6-9ea3-2ad68818503f",
        "storage_key": "property/5694569974857728/019f1510-d384-77d6-9ea3-2ad68818503f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://melbournecc.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=419392350640997603&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "melbourne-central-catholic-high-school",
      "poi_latitude": "28.0578926",
      "poi_longitude": "-80.6169942",
      "poi_miles_from_property": "8.4 mi",
      "poi_walking_minutes": "3 hours 5 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 321-727-0793",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f150f-37ef-74de-abb7-2b8044b418ed.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-37ef-74de-abb7-2b8044b418ed",
        "storage_key": "property/5694569974857728/019f150f-37ef-74de-abb7-2b8044b418ed.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJO1wbwhAS3ogR4wR58R770QU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "ec_b946ccd7fe89d33b3ad25fa0",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "source": "generator",
      "poi_name": "Our Lady of Lourdes Catholic School",
      "poi_type": "Education",
      "poi_address": "420 E Fee Ave, Melbourne, FL 32901, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f1510-d5d8-76bf-9cf4-980085427a4c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1510-d5d8-76bf-9cf4-980085427a4c",
        "storage_key": "property/5694569974857728/019f1510-d5d8-76bf-9cf4-980085427a4c.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.ollmelbourne.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12795905913322369849&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "our-lady-of-lourdes-catholic-school",
      "poi_latitude": "28.0825883",
      "poi_longitude": "-80.6141306",
      "poi_miles_from_property": "6.5 mi",
      "poi_walking_minutes": "2 hours 25 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 321-723-3631",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f150f-37ef-74de-abb7-2b8044b418ed.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-37ef-74de-abb7-2b8044b418ed",
        "storage_key": "property/5694569974857728/019f150f-37ef-74de-abb7-2b8044b418ed.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJpwiNyBoR3ogROXPm7qEwlLE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_d836795f12ffb2a2a022171a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "source": "generator",
      "poi_name": "Rossetter House Museum Office",
      "poi_type": "Entertainment",
      "poi_address": "1320 Highland Ave, Melbourne, FL 32935, USA",
      "poi_short_description": "Guided tours of the early-1900s private home & gardens of a prominent local resident.",
      "poi_long_description": "Guided tours of the early-1900s private home & gardens of a prominent local resident.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f1510-d562-718e-9351-68d8bddab3a7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1510-d562-718e-9351-68d8bddab3a7",
        "storage_key": "property/5694569974857728/019f1510-d562-718e-9351-68d8bddab3a7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.rossetterhousemuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15819060041167113074&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rossetter-house-museum-office",
      "poi_latitude": "28.1285407",
      "poi_longitude": "-80.62631879999999",
      "poi_miles_from_property": "3.2 mi",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 321-254-9855",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f150f-37e3-72b9-a07f-a81629df49b4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-37e3-72b9-a07f-a81629df49b4",
        "storage_key": "property/5694569974857728/019f150f-37e3-72b9-a07f-a81629df49b4.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJZaW0QC8Q3ogRcotXYkuXiNs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "ec_9c92163a6948ad68b666e54e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "source": "generator",
      "poi_name": "Squid Lips",
      "poi_type": "Entertainment",
      "poi_address": "1477 Pineapple Ave, Melbourne, FL 32935, USA",
      "poi_short_description": "Chill eatery serving uniquely prepared seafood, including bacon-wrapped scallops & smoked fish dip.",
      "poi_long_description": "Chill eatery serving uniquely prepared seafood, including bacon-wrapped scallops & smoked fish dip.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f150e-59eb-716b-9863-66bf7558696e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-59eb-716b-9863-66bf7558696e",
        "storage_key": "property/5694569974857728/019f150e-59eb-716b-9863-66bf7558696e.webp",
        "width": 1000,
        "height": 750
      },
      "poi_business_url": "http://www.squidlipsgrill.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2967694236063990326&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "squid-lips",
      "poi_latitude": "28.1315025",
      "poi_longitude": "-80.6253898",
      "poi_miles_from_property": "3.2 mi",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 321-259-3101",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f150f-3834-73b2-b0fa-70015c12271f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-3834-73b2-b0fa-70015c12271f",
        "storage_key": "property/5694569974857728/019f150f-3834-73b2-b0fa-70015c12271f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJTzPvvyUQ3ogRNoKRJi9eLyk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "ec_25bde6350a90f9ad14e82f71",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "source": "generator",
      "poi_name": "Sully's Backstreet Bar",
      "poi_type": "Entertainment",
      "poi_address": "1841 Avocado Ave, Melbourne, FL 32935, USA",
      "poi_short_description": "Neighborhood bar featuring live music and an outdoor area with beer and darts.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f1510-dafc-76cc-9725-e6633942b230.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1510-dafc-76cc-9725-e6633942b230",
        "storage_key": "property/5694569974857728/019f1510-dafc-76cc-9725-e6633942b230.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=15095818761471860573&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sullys-backstreet-bar",
      "poi_latitude": "28.1369934",
      "poi_longitude": "-80.6327362",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 321-253-1202",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f150f-37e3-72b9-a07f-a6c52c7361c1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-37e3-72b9-a07f-a6c52c7361c1",
        "storage_key": "property/5694569974857728/019f150f-37e3-72b9-a07f-a6c52c7361c1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4zCIpyAQ3ogRXR81ty4ff9E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar"
    },
    {
      "id": "ec_39dae3f5cb909901e9a11bb5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "source": "generator",
      "poi_name": "Henegar Center For the Arts",
      "poi_type": "Entertainment",
      "poi_address": "625 E New Haven Ave #119, Melbourne, FL 32901, USA",
      "poi_short_description": "Expansive, proscenium-style stage for musicals & more with a mirrored dance studio & art exhibits.",
      "poi_long_description": "Expansive, proscenium-style stage for musicals & more with a mirrored dance studio & art exhibits.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f1510-d7d3-7109-8f8e-d5aa7d491dc2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1510-d7d3-7109-8f8e-d5aa7d491dc2",
        "storage_key": "property/5694569974857728/019f1510-d7d3-7109-8f8e-d5aa7d491dc2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.henegarcenter.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6024634720706584977&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "henegar-center-for-the-arts",
      "poi_latitude": "28.0781009",
      "poi_longitude": "-80.61024669999999",
      "poi_miles_from_property": "7.0 mi",
      "poi_walking_minutes": "2 hours 35 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 321-723-8698",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f150f-381c-76c8-a538-0b9e5750637a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-381c-76c8-a538-0b9e5750637a",
        "storage_key": "property/5694569974857728/019f150f-381c-76c8-a538-0b9e5750637a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJe7mvNPMR3ogRkWEzzVvNm1M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "ec_6cdd63355a1d1a771356fa05",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "source": "generator",
      "poi_name": "Maxwell C. King Center for the Performing Arts",
      "poi_type": "Entertainment",
      "poi_address": "3865 N Wickham Rd, Melbourne, FL 32935, USA",
      "poi_short_description": "Modern venue hosts bands, musicals, comedy shows & other all-ages performances in an intimate space.",
      "poi_long_description": "Modern venue hosts bands, musicals, comedy shows & other all-ages performances in an intimate space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f1510-d635-70c5-80e7-1721a4e2359c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1510-d635-70c5-80e7-1721a4e2359c",
        "storage_key": "property/5694569974857728/019f1510-d635-70c5-80e7-1721a4e2359c.webp",
        "width": 1280,
        "height": 943
      },
      "poi_business_url": "http://www.kingcenter.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3025395646644299614&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "maxwell-c-king-center-for-the-performing-arts",
      "poi_latitude": "28.1705878",
      "poi_longitude": "-80.669401",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 321-242-2219",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f150f-381c-76c8-a538-0b9e5750637a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-381c-76c8-a538-0b9e5750637a",
        "storage_key": "property/5694569974857728/019f150f-381c-76c8-a538-0b9e5750637a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJzUvSA34F3ogRXic_t09d_Ck",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "ec_01aa27ca5c6c8b4da0590d35",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "source": "generator",
      "poi_name": "Brevard Zoo",
      "poi_type": "Entertainment",
      "poi_address": "8225 N Wickham Rd, Melbourne, FL 32940, USA",
      "poi_short_description": "Attractions include 500+ animals, a chance to feed giraffes, zip-lining & a kids' water play area.",
      "poi_long_description": "Attractions include 500+ animals, a chance to feed giraffes, zip-lining & a kids' water play area.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f150e-bd74-73c9-a2b7-74ab9b9ce00c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-bd74-73c9-a2b7-74ab9b9ce00c",
        "storage_key": "property/5694569974857728/019f150e-bd74-73c9-a2b7-74ab9b9ce00c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.brevardzoo.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5323358647013922720&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "brevard-zoo",
      "poi_latitude": "28.2249886",
      "poi_longitude": "-80.7138556",
      "poi_miles_from_property": "7.7 mi",
      "poi_walking_minutes": "2 hours 47 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 321-254-9453",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f150f-381c-76c8-a538-0b9e5750637a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-381c-76c8-a538-0b9e5750637a",
        "storage_key": "property/5694569974857728/019f150f-381c-76c8-a538-0b9e5750637a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJI0Ja3y4E3ogRoNdEL3xe4Ek",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "zoo"
    },
    {
      "id": "ec_faaedb1537df8bb4c94b4ebf",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "source": "generator",
      "poi_name": "Fifth Avenue Art Gallery",
      "poi_type": "Entertainment",
      "poi_address": "1470 Highland Ave, Melbourne, FL 32935, USA",
      "poi_short_description": "Artist-owned gallery showcasing locally produced works of fine art & craft, plus jewelry.",
      "poi_long_description": "Artist-owned gallery showcasing locally produced works of fine art & craft, plus jewelry.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f1510-da82-713a-b7dd-7f7c6c98e6e1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1510-da82-713a-b7dd-7f7c6c98e6e1",
        "storage_key": "property/5694569974857728/019f1510-da82-713a-b7dd-7f7c6c98e6e1.webp",
        "width": 668,
        "height": 668
      },
      "poi_business_url": "https://fifthavenueartgallery.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13464457155078960970&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fifth-avenue-art-gallery",
      "poi_latitude": "28.1308292",
      "poi_longitude": "-80.6275525",
      "poi_miles_from_property": "3.1 mi",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 321-259-8261",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f150f-381c-76c8-a538-0b9e5750637a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-381c-76c8-a538-0b9e5750637a",
        "storage_key": "property/5694569974857728/019f150f-381c-76c8-a538-0b9e5750637a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJnz5ZDyYQ3ogRSrfy3XFc27o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "art_gallery"
    },
    {
      "id": "ec_111bcb46a6d8471541b3dc25",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "source": "generator",
      "poi_name": "Dreamland Mini Golf & More",
      "poi_type": "Entertainment",
      "poi_address": "1418 Highland Ave, Melbourne, FL 32935, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f1510-db65-722c-9d71-249e94b4c273.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1510-db65-722c-9d71-249e94b4c273",
        "storage_key": "property/5694569974857728/019f1510-db65-722c-9d71-249e94b4c273.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://derekgores.com/dreamland/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10200569451360553256&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dreamland-mini-golf--more",
      "poi_latitude": "28.1300836",
      "poi_longitude": "-80.6270144",
      "poi_miles_from_property": "3.1 mi",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 321-468-3251",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f150f-381c-76c8-a538-0b9e5750637a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-381c-76c8-a538-0b9e5750637a",
        "storage_key": "property/5694569974857728/019f150f-381c-76c8-a538-0b9e5750637a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJLyL25ZoR3ogRKAkM_96zj40",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "miniature_golf_course"
    },
    {
      "id": "ec_505fe38f3ff24587fcb3fdf9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "source": "generator",
      "poi_name": "Intracoastal Brewing Company",
      "poi_type": "Entertainment",
      "poi_address": "652 W Eau Gallie Blvd, Melbourne, FL 32935, USA",
      "poi_short_description": "Neighborhood taproom featuring a rotating menu of original brews, plus growlers to take home.",
      "poi_long_description": "Neighborhood taproom featuring a rotating menu of original brews, plus growlers to take home.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f1510-dc76-75b9-b294-83da457c14f7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1510-dc76-75b9-b294-83da457c14f7",
        "storage_key": "property/5694569974857728/019f1510-dc76-75b9-b294-83da457c14f7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.intracoastalbrewingcompany.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1542781442614938272&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "intracoastal-brewing-company",
      "poi_latitude": "28.1298306",
      "poi_longitude": "-80.6289611",
      "poi_miles_from_property": "3.0 mi",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 321-872-7395",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f150f-381c-76c8-a538-0b9e5750637a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-381c-76c8-a538-0b9e5750637a",
        "storage_key": "property/5694569974857728/019f150f-381c-76c8-a538-0b9e5750637a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJC3q4nigQ3ogRoMogTYwPaRU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "brewery"
    },
    {
      "id": "ec_c9699bdd736e536f698e1b41",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "source": "generator",
      "poi_name": "Hell 'n Blazes Brewing Company",
      "poi_type": "Entertainment",
      "poi_address": "1002 E New Haven Ave, Melbourne, FL 32901, USA",
      "poi_short_description": "Burgers, poutine, and other pub grub served alongside housemade beers in a casual setting.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f1510-dc80-701d-9a4d-07dedeac2e88.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1510-dc80-701d-9a4d-07dedeac2e88",
        "storage_key": "property/5694569974857728/019f1510-dc80-701d-9a4d-07dedeac2e88.webp",
        "width": 641,
        "height": 960
      },
      "poi_business_url": "http://www.hellnblazesbrewing.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5678992341928824486&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hell-n-blazes-brewing-company",
      "poi_latitude": "28.0786249",
      "poi_longitude": "-80.6041805",
      "poi_miles_from_property": "7.2 mi",
      "poi_walking_minutes": "2 hours 39 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 321-821-4052",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f150f-3834-73b2-b0fa-70015c12271f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-3834-73b2-b0fa-70015c12271f",
        "storage_key": "property/5694569974857728/019f150f-3834-73b2-b0fa-70015c12271f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9QD8j44R3ogRps7URnLVz04",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_ad03568b9f16c817df009461",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "source": "generator",
      "poi_name": "Orlando Health Melbourne Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "250 N Wickham Rd, Melbourne, FL 32935, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f150e-c0a9-76de-b019-d4e3a7b0e091.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-c0a9-76de-b019-d4e3a7b0e091",
        "storage_key": "property/5694569974857728/019f150e-c0a9-76de-b019-d4e3a7b0e091.webp",
        "width": 1080,
        "height": 864
      },
      "poi_business_url": "https://www.orlandohealth.com/facilities/melbourne-hospital",
      "poi_directions_map_url": "https://maps.google.com/?cid=5395501980447306260&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "orlando-health-melbourne-hospital",
      "poi_latitude": "28.1095255",
      "poi_longitude": "-80.6751025",
      "poi_miles_from_property": "3.1 mi",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 321-752-1200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f150f-3834-73b2-b0fa-763d96e43488.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-3834-73b2-b0fa-763d96e43488",
        "storage_key": "property/5694569974857728/019f150f-3834-73b2-b0fa-763d96e43488.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJhYfQMlgO3ogRFHJ68Xas4Eo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "ec_d69ab3ddefc201847ed323c5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "source": "generator",
      "poi_name": "Eau Gallie Arts District MedFast Urgent Care Business Office",
      "poi_type": "Health and Wellness",
      "poi_address": "1532 N Harbor City Blvd, Melbourne, FL 32935, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f1510-dff1-76c5-88c8-bb7dac4b4a7d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1510-dff1-76c5-88c8-bb7dac4b4a7d",
        "storage_key": "property/5694569974857728/019f1510-dff1-76c5-88c8-bb7dac4b4a7d.webp",
        "width": 1280,
        "height": 1035
      },
      "poi_business_url": "http://www.medfastcare.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2645666191432581207&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "eau-gallie-arts-district-medfast-urgent-care-business-office",
      "poi_latitude": "28.1316765",
      "poi_longitude": "-80.6317979",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 321-409-9409",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f150f-381c-76c8-a538-0b9e5750637a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-381c-76c8-a538-0b9e5750637a",
        "storage_key": "property/5694569974857728/019f150f-381c-76c8-a538-0b9e5750637a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_XbkjYwR3ogRV4CZPmJLtyQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_12f1252938feb5bb9464016c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "source": "generator",
      "poi_name": "Walgreens",
      "poi_type": "Health and Wellness",
      "poi_address": "1350 N Wickham Rd, Melbourne, FL 32935, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f1510-df3b-742b-a140-a9bafae4ceb9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1510-df3b-742b-a140-a9bafae4ceb9",
        "storage_key": "property/5694569974857728/019f1510-df3b-742b-a140-a9bafae4ceb9.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-1350+n+wickham+rd-melbourne-fl-32935/id=4193",
      "poi_directions_map_url": "https://maps.google.com/?cid=6892959094280497489&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "28.1291265",
      "poi_longitude": "-80.6722684",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 321-254-5507",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f150f-381c-76c8-a538-0b9e5750637a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-381c-76c8-a538-0b9e5750637a",
        "storage_key": "property/5694569974857728/019f150f-381c-76c8-a538-0b9e5750637a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJox-qMKkP3ogRUSnjmca1qF8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "ec_05edf7308977d470a72af2d1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "source": "generator",
      "poi_name": "CVS",
      "poi_type": "Health and Wellness",
      "poi_address": "1800 N Wickham Rd, Melbourne, FL 32935, USA",
      "poi_short_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_long_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f1510-e0cc-7785-ba73-d274194fe9ea.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1510-e0cc-7785-ba73-d274194fe9ea",
        "storage_key": "property/5694569974857728/019f1510-e0cc-7785-ba73-d274194fe9ea.webp",
        "width": 1280,
        "height": 591
      },
      "poi_business_url": "https://www.cvs.com/store-locator/melbourne-fl-pharmacies/1800-n-wickham-rd-melbourne-fl-32935/storeid=573?WT.mc_id=LS_GOOGLE_FS_573",
      "poi_directions_map_url": "https://maps.google.com/?cid=11153487980944318949&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs",
      "poi_latitude": "28.1363911",
      "poi_longitude": "-80.6722748",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 321-259-2333",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f150f-381c-76c8-a538-0b9e5750637a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-381c-76c8-a538-0b9e5750637a",
        "storage_key": "property/5694569974857728/019f150f-381c-76c8-a538-0b9e5750637a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2WE-fqYP3ogR5WHGljkmyZo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "ec_33c09a8da83bd6dffa221540",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "source": "generator",
      "poi_name": "Publix Pharmacy at Lake Washington Crossing",
      "poi_type": "Health and Wellness",
      "poi_address": "3200 Lake Washington Rd, Melbourne, FL 32934, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f1510-e3e2-7209-8221-4da1b8c78bb5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1510-e3e2-7209-8221-4da1b8c78bb5",
        "storage_key": "property/5694569974857728/019f1510-e3e2-7209-8221-4da1b8c78bb5.webp",
        "width": 1280,
        "height": 591
      },
      "poi_business_url": "https://www.publix.com/pharmacy?utm_medium=maps&utm_source=google&utm_content=psmpharm_google_override",
      "poi_directions_map_url": "https://maps.google.com/?cid=6414748727851265093&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "publix-pharmacy-at-lake-washington-crossing",
      "poi_latitude": "28.1475606",
      "poi_longitude": "-80.6743448",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 321-426-2209",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f1511-019c-77ae-9ec5-30c0803b320b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1511-019c-77ae-9ec5-30c0803b320b",
        "storage_key": "property/5694569974857728/019f1511-019c-77ae-9ec5-30c0803b320b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJwj5qp8P3ogRRaz2LvvDBVk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_0626e04cce3e87df8836bc6d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "source": "generator",
      "poi_name": "LA Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "2447 N Wickham Rd #102, Melbourne, FL 32935, USA",
      "poi_short_description": "Chain gym offering cardio and strength equipment, classes, a pool, sauna, and basketball court, plus child care.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f150e-b61d-7447-a66e-ed77ef166177.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-b61d-7447-a66e-ed77ef166177",
        "storage_key": "property/5694569974857728/019f150e-b61d-7447-a66e-ed77ef166177.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.lafitness.com/Pages/clubhome.aspx?clubid=1021&utm_source=google&utm_medium=googlemaps&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=9460107095062682922&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "la-fitness",
      "poi_latitude": "28.1463126",
      "poi_longitude": "-80.6696142",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 321-216-2280",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f150f-381c-76c8-a538-0b9e5750637a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-381c-76c8-a538-0b9e5750637a",
        "storage_key": "property/5694569974857728/019f150f-381c-76c8-a538-0b9e5750637a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJoRlevpgP3ogRKh1d-kcNSYM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_3507c9cb291f59e129a2251b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "source": "generator",
      "poi_name": "Crunch Fitness - Wickham",
      "poi_type": "Health and Wellness",
      "poi_address": "4880 N Wickham Rd, Melbourne, FL 32940, USA",
      "poi_short_description": "Casual fitness chain featuring group classes, cardio machines and weight-training equipment.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f150e-9549-75ec-a605-488de8db5e5e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-9549-75ec-a605-488de8db5e5e",
        "storage_key": "property/5694569974857728/019f150e-9549-75ec-a605-488de8db5e5e.webp",
        "width": 1024,
        "height": 575
      },
      "poi_business_url": "https://www.crunch.com/locations/wickham",
      "poi_directions_map_url": "https://maps.google.com/?cid=13899806960225722526&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "crunch-fitness---wickham",
      "poi_latitude": "28.1876106",
      "poi_longitude": "-80.6738739",
      "poi_miles_from_property": "3.3 mi",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 321-499-2243",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f150f-381c-76c8-a538-0b9e5750637a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-381c-76c8-a538-0b9e5750637a",
        "storage_key": "property/5694569974857728/019f150f-381c-76c8-a538-0b9e5750637a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJvVqb9dAF3ogRnqDBNskI5sA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_6ea8884ada30228eb52aba82",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "source": "generator",
      "poi_name": "Anytime Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "1270 N Wickham Rd, Melbourne, FL 32935, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f1510-e374-709a-8e20-8ff361084c11.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1510-e374-709a-8e20-8ff361084c11",
        "storage_key": "property/5694569974857728/019f1510-e374-709a-8e20-8ff361084c11.webp",
        "width": 671,
        "height": 503
      },
      "poi_business_url": "https://www.anytimefitness.com/locations/melbourne-florida-3808/?utm_source=google&utm_medium=organic-businesslisting&utm_campaign=gbp-listing&utm_content=3808",
      "poi_directions_map_url": "https://maps.google.com/?cid=978860556107724088&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "anytime-fitness",
      "poi_latitude": "28.1270687",
      "poi_longitude": "-80.6738117",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 321-242-0525",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f150f-381c-76c8-a538-0b9e5750637a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-381c-76c8-a538-0b9e5750637a",
        "storage_key": "property/5694569974857728/019f150f-381c-76c8-a538-0b9e5750637a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJgYrlzqsP3ogRODVxU32clQ0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_f72bce36a629e707fd004cdf",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "source": "generator",
      "poi_name": "The Yoga Garden",
      "poi_type": "Health and Wellness",
      "poi_address": "1482 Pineapple Ave, Melbourne, FL 32935, USA",
      "poi_short_description": "Yoga studio offering adult and beginner classes in a bright, welcoming space.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f1510-e3e0-739f-a3ae-bbd983d703ab.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1510-e3e0-739f-a3ae-bbd983d703ab",
        "storage_key": "property/5694569974857728/019f1510-e3e0-739f-a3ae-bbd983d703ab.webp",
        "width": 1024,
        "height": 683
      },
      "poi_business_url": "http://yogagardenfl.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3959338979248746915&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-yoga-garden",
      "poi_latitude": "28.1310404",
      "poi_longitude": "-80.62645189999999",
      "poi_miles_from_property": "3.1 mi",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 321-345-6197",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f150f-37ef-74de-abb7-2b8044b418ed.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-37ef-74de-abb7-2b8044b418ed",
        "storage_key": "property/5694569974857728/019f150f-37ef-74de-abb7-2b8044b418ed.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJHdgB5iUQ3ogRo7F6-9Jl8jY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "ec_d837ec4761eb5f9bdd33e1b0",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "source": "generator",
      "poi_name": "Orangetheory Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "6365 N Wickham Rd D301, Melbourne, FL 32940, USA",
      "poi_short_description": "Gym offering cardio and strength classes using treadmills and rowers and weight sets.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f1510-ed3a-73d9-b3e3-f53e3e44d7ab.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1510-ed3a-73d9-b3e3-f53e3e44d7ab",
        "storage_key": "property/5694569974857728/019f1510-ed3a-73d9-b3e3-f53e3e44d7ab.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.orangetheory.com/en-us/locations/melbourne-florida-0417?utm_medium=seo&utm_source=gg&utm_term=corporate&utm_campaign=soci",
      "poi_directions_map_url": "https://maps.google.com/?cid=15142265546112584329&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "orangetheory-fitness",
      "poi_latitude": "28.2164191",
      "poi_longitude": "-80.6720084",
      "poi_miles_from_property": "5.3 mi",
      "poi_walking_minutes": "1 hour 58 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 321-800-4466",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f150f-381c-76c8-a538-0b9e5750637a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-381c-76c8-a538-0b9e5750637a",
        "storage_key": "property/5694569974857728/019f150f-381c-76c8-a538-0b9e5750637a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJK0CYGf4E3ogRiUqtekkiJNI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_2adb9cf7ea2947cda86dfa80",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "source": "generator",
      "poi_name": "Wickham Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2500 Parkway Dr, Melbourne, FL 32935, USA",
      "poi_short_description": "A 391-acre preserve offering recreational options from a campground to trails to a community center.",
      "poi_long_description": "A 391-acre preserve offering recreational options from a campground to trails to a community center.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f1510-e835-71d9-823e-48ccbe583f41.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1510-e835-71d9-823e-48ccbe583f41",
        "storage_key": "property/5694569974857728/019f1510-e835-71d9-823e-48ccbe583f41.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.brevardfl.gov/ParksAndRecreation/ParkDirectory/WickhamPark",
      "poi_directions_map_url": "https://maps.google.com/?cid=10706711957469019189&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wickham-park",
      "poi_latitude": "28.1640516",
      "poi_longitude": "-80.6623935",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 321-255-4307",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f150f-3833-7678-9960-587bd0ca69d2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-3833-7678-9960-587bd0ca69d2",
        "storage_key": "property/5694569974857728/019f150f-3833-7678-9960-587bd0ca69d2.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJk26ohIsP3ogRNTxeeczhlZQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_26ec00c8d6f678c4a21d0a5d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "source": "generator",
      "poi_name": "Lake Washington Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "6000 Lake Washington Rd, Melbourne, FL 32934, USA",
      "poi_short_description": "Park with a public boat ramp, picnic areas, playground, fishing, and dock.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f1510-ec1a-74a8-9f9c-aacac4c5edb8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1510-ec1a-74a8-9f9c-aacac4c5edb8",
        "storage_key": "property/5694569974857728/019f1510-ec1a-74a8-9f9c-aacac4c5edb8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.brevardfl.gov/ParksAndRecreation/ParkDirectory/LakeWashington",
      "poi_directions_map_url": "https://maps.google.com/?cid=18138337279277178870&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lake-washington-park",
      "poi_latitude": "28.1476547",
      "poi_longitude": "-80.73323839999999",
      "poi_miles_from_property": "4.2 mi",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 321-255-4400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f150f-3833-7678-9960-587bd0ca69d2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-3833-7678-9960-587bd0ca69d2",
        "storage_key": "property/5694569974857728/019f150f-3833-7678-9960-587bd0ca69d2.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2UCh6McI3ogR9p-Ki6dRuPs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_a6e7a943db90c8cba53750db",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "source": "generator",
      "poi_name": "Ballard Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "924 Thomas Barbour Dr, Melbourne, FL 32935, USA",
      "poi_short_description": "Riverfront park with sport courts, boat ramps, a playground & picnic facilities.",
      "poi_long_description": "Riverfront park with sport courts, boat ramps, a playground & picnic facilities.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f1510-e60b-740b-8ff5-85846fa895c3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1510-e60b-740b-8ff5-85846fa895c3",
        "storage_key": "property/5694569974857728/019f1510-e60b-740b-8ff5-85846fa895c3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.melbourneflorida.org/departments/parks-recreation",
      "poi_directions_map_url": "https://maps.google.com/?cid=3196459742219984286&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ballard-park",
      "poi_latitude": "28.1247476",
      "poi_longitude": "-80.6249955",
      "poi_miles_from_property": "4.5 mi",
      "poi_walking_minutes": "1 hour 39 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 321-255-4608",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f150f-3833-7678-9960-587bd0ca69d2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-3833-7678-9960-587bd0ca69d2",
        "storage_key": "property/5694569974857728/019f150f-3833-7678-9960-587bd0ca69d2.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJUZJohy4Q3ogRnt3bMTMbXCw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_1dd9c287245079948973e880",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "source": "generator",
      "poi_name": "Pieloch Dog Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1550 Mosswood Dr, Melbourne, FL 32935, USA",
      "poi_short_description": "Popular park for dogs of all sizes, featuring an obstacle course, a splash pad and water spigots.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f1510-e6a8-77e8-98a1-2e09a3d53fb7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1510-e6a8-77e8-98a1-2e09a3d53fb7",
        "storage_key": "property/5694569974857728/019f1510-e6a8-77e8-98a1-2e09a3d53fb7.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=1980768430916252217&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pieloch-dog-park",
      "poi_latitude": "28.1323339",
      "poi_longitude": "-80.64249579999999",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f150f-3833-7678-9960-587bd0ca69d2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-3833-7678-9960-587bd0ca69d2",
        "storage_key": "property/5694569974857728/019f150f-3833-7678-9960-587bd0ca69d2.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJrUAFHugP3ogROTISs2QafRs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_06728370d46108c384e764fc",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "source": "generator",
      "poi_name": "Pineapple Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Melbourne, FL 32935, USA",
      "poi_short_description": "Quiet waterside, family-friendly space offering a play area and dolphin viewing.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f1510-e7bf-716e-a72f-248242513bbe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1510-e7bf-716e-a72f-248242513bbe",
        "storage_key": "property/5694569974857728/019f1510-e7bf-716e-a72f-248242513bbe.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.melbourneflorida.org/Home/Components/FacilityDirectory/FacilityDirectory/90/1539?npage=2",
      "poi_directions_map_url": "https://maps.google.com/?cid=1584168406901306626&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pineapple-park",
      "poi_latitude": "28.1326352",
      "poi_longitude": "-80.6263057",
      "poi_miles_from_property": "3.1 mi",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 321-608-7400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f150f-3833-7678-9960-587bd0ca69d2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-3833-7678-9960-587bd0ca69d2",
        "storage_key": "property/5694569974857728/019f150f-3833-7678-9960-587bd0ca69d2.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ39Kn0XcR3ogRArW_1cUY_BU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_f42e5bbaa5eb548cd83399af",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "source": "generator",
      "poi_name": "Claude Edge Front St. Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2205 Front St, Melbourne, FL 32901, USA",
      "poi_short_description": "Waterfront hangout with a boat launch, fishing pier & picnic tables, plus a gazebo for events.",
      "poi_long_description": "Waterfront hangout with a boat launch, fishing pier & picnic tables, plus a gazebo for events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f1510-e840-7419-8fbc-15d5e2efb14e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1510-e840-7419-8fbc-15d5e2efb14e",
        "storage_key": "property/5694569974857728/019f1510-e840-7419-8fbc-15d5e2efb14e.webp",
        "width": 1200,
        "height": 900
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=3167456464213035161&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "claude-edge-front-st-park",
      "poi_latitude": "28.0789881",
      "poi_longitude": "-80.6000607",
      "poi_miles_from_property": "7.3 mi",
      "poi_walking_minutes": "2 hours 42 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 321-608-7260",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f150f-3833-7678-9960-587bd0ca69d2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-3833-7678-9960-587bd0ca69d2",
        "storage_key": "property/5694569974857728/019f150f-3833-7678-9960-587bd0ca69d2.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6VqNnI8R3ogRmcjuTt8Q9Ss",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_026e4d8bc716a3a210511165",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "source": "generator",
      "poi_name": "Riverview Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2301-2499 Irwin St, Melbourne, FL 32901, USA",
      "poi_short_description": "Waterfront rec area, featuring covered picnic tables, a dog park, jungle gym and more.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f1510-ed36-76ea-94cc-7c928f73d9b4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1510-ed36-76ea-94cc-7c928f73d9b4",
        "storage_key": "property/5694569974857728/019f1510-ed36-76ea-94cc-7c928f73d9b4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.melbourneflorida.org/Home/Components/FacilityDirectory/FacilityDirectory/50/1539?npage=2",
      "poi_directions_map_url": "https://maps.google.com/?cid=10660442595722250641&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "riverview-park",
      "poi_latitude": "28.0729477",
      "poi_longitude": "-80.5999842",
      "poi_miles_from_property": "7.6 mi",
      "poi_walking_minutes": "2 hours 48 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 321-608-7400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f150f-3833-7678-9960-587bd0ca69d2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-3833-7678-9960-587bd0ca69d2",
        "storage_key": "property/5694569974857728/019f150f-3833-7678-9960-587bd0ca69d2.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJlfpqfYgR3ogRkcl3Mg-A8ZM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_025bedecaeb75b16241abd22",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "source": "generator",
      "poi_name": "Eau Gallie Square Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1452 Highland Ave, Melbourne, FL 32935, USA",
      "poi_short_description": "City park featuring an oak tree, live music, and events, plus benches and off-street parking.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f1510-ed54-7428-a4cd-3455f823acbc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1510-ed54-7428-a4cd-3455f823acbc",
        "storage_key": "property/5694569974857728/019f1510-ed54-7428-a4cd-3455f823acbc.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=17539305837826883534&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "eau-gallie-square-park",
      "poi_latitude": "28.130787",
      "poi_longitude": "-80.6270548",
      "poi_miles_from_property": "3.1 mi",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f150f-3833-7678-9960-587bd0ca69d2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-3833-7678-9960-587bd0ca69d2",
        "storage_key": "property/5694569974857728/019f150f-3833-7678-9960-587bd0ca69d2.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ86_G_CUQ3ogRzj-bdrshaPM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "ec_6678f25ca1bdb6ebe7190f02",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "source": "generator",
      "poi_name": "Howard E. Futch Memorial Park at Paradise Beach",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2301 Jimmy Buffett Mem Hwy, Melbourne, FL 32903, USA",
      "poi_short_description": "A beach with seasonal lifeguards, plus a playground,  volleyball courts, picnic pavilions & grills.",
      "poi_long_description": "A beach with seasonal lifeguards, plus a playground,  volleyball courts, picnic pavilions & grills.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f1510-f0cf-74c8-b61c-a5502102aad7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1510-f0cf-74c8-b61c-a5502102aad7",
        "storage_key": "property/5694569974857728/019f1510-f0cf-74c8-b61c-a5502102aad7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.brevardfl.gov/ParksAndRecreation/ParkDirectory/HowardFutch",
      "poi_directions_map_url": "https://maps.google.com/?cid=6938396659636853044&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "howard-e-futch-memorial-park-at-paradise-beach",
      "poi_latitude": "28.1233738",
      "poi_longitude": "-80.5752399",
      "poi_miles_from_property": "7.1 mi",
      "poi_walking_minutes": "2 hours 35 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 321-255-4400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f150f-3833-7678-9960-587bd0ca69d2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-3833-7678-9960-587bd0ca69d2",
        "storage_key": "property/5694569974857728/019f150f-3833-7678-9960-587bd0ca69d2.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJjaJB4-IQ3ogRNFlpMAAjSmA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_4eafca7d6c45f9d4de919fdc",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "source": "generator",
      "poi_name": "Rossetter House Museum Office",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1320 Highland Ave, Melbourne, FL 32935, USA",
      "poi_short_description": "Guided tours of the early-1900s private home & gardens of a prominent local resident.",
      "poi_long_description": "Guided tours of the early-1900s private home & gardens of a prominent local resident.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f1510-d562-718e-9351-68d8bddab3a7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1510-d562-718e-9351-68d8bddab3a7",
        "storage_key": "property/5694569974857728/019f1510-d562-718e-9351-68d8bddab3a7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.rossetterhousemuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15819060041167113074&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rossetter-house-museum-office",
      "poi_latitude": "28.1285407",
      "poi_longitude": "-80.62631879999999",
      "poi_miles_from_property": "3.2 mi",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 321-254-9855",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f150f-37e3-72b9-a07f-a81629df49b4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-37e3-72b9-a07f-a81629df49b4",
        "storage_key": "property/5694569974857728/019f150f-37e3-72b9-a07f-a81629df49b4.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJZaW0QC8Q3ogRcotXYkuXiNs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "ec_197d0f4c33d822445db017d8",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "source": "generator",
      "poi_name": "Viera",
      "poi_type": "Transportation & Transit",
      "poi_address": "5545 Porada Dr, Rockledge, FL 32955, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=17981409177874895154&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "viera",
      "poi_latitude": "28.2655066",
      "poi_longitude": "-80.7378688",
      "poi_miles_from_property": "11.6 mi",
      "poi_walking_minutes": "4 hours 13 mins",
      "poi_biking_minutes": "1 hour 0 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 321-952-4563",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f1511-019d-716e-bb0a-4b7c18b35b01.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1511-019d-716e-bb0a-4b7c18b35b01",
        "storage_key": "property/5694569974857728/019f1511-019d-716e-bb0a-4b7c18b35b01.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6c8MqUwB3ogRMpEusGDMivk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "parking_lot"
    },
    {
      "id": "ec_ef411e9005146e587b68b3e4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "source": "generator",
      "poi_name": "Park & Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "W Eau Gallie Blvd, Melbourne, FL 32934, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f1510-f24a-7708-954d-5b5d870f527b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1510-f24a-7708-954d-5b5d870f527b",
        "storage_key": "property/5694569974857728/019f1510-f24a-7708-954d-5b5d870f527b.webp",
        "width": 1280,
        "height": 950
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=13924351275386328797&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "park--ride",
      "poi_latitude": "28.1207518",
      "poi_longitude": "-80.71330859999999",
      "poi_miles_from_property": "4.4 mi",
      "poi_walking_minutes": "1 hour 36 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f1511-019d-716e-bb0a-4b7c18b35b01.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1511-019d-716e-bb0a-4b7c18b35b01",
        "storage_key": "property/5694569974857728/019f1511-019d-716e-bb0a-4b7c18b35b01.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJx1yWrtkO3ogR3dYo6bU7PcE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "ec_c3acbb249d4836a323ff69d5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "source": "generator",
      "poi_name": "Melbourne Orlando International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "1 Air Terminal Pkwy, Melbourne, FL 32901, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f150e-ee69-76bf-830b-4b58449430d9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-ee69-76bf-830b-4b58449430d9",
        "storage_key": "property/5694569974857728/019f150e-ee69-76bf-830b-4b58449430d9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.mlbair.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10996310418774269143&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "melbourne-orlando-international-airport",
      "poi_latitude": "28.1012659",
      "poi_longitude": "-80.645078",
      "poi_miles_from_property": "6.3 mi",
      "poi_walking_minutes": "2 hours 17 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 321-723-6227",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f150f-3ad9-720e-9826-31e296e1ba5c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-3ad9-720e-9826-31e296e1ba5c",
        "storage_key": "property/5694569974857728/019f150f-3ad9-720e-9826-31e296e1ba5c.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJtzLs29gR3ogR15z3nhC-mpg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "ec_f750f75b63485c9a205519cc",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "source": "generator",
      "poi_name": "Greyhound: Bus Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "4520 W New Haven Ave, Melbourne, FL 32904, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f1510-f58a-7400-85f0-025bc346565d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1510-f58a-7400-85f0-025bc346565d",
        "storage_key": "property/5694569974857728/019f1510-f58a-7400-85f0-025bc346565d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.greyhound.com/en-us/bus-station-470987",
      "poi_directions_map_url": "https://maps.google.com/?cid=83228213412508812&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "greyhound-bus-station",
      "poi_latitude": "28.0791761",
      "poi_longitude": "-80.7023851",
      "poi_miles_from_property": "6.6 mi",
      "poi_walking_minutes": "2 hours 24 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 321-723-4323",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f150f-381c-76c8-a538-0b9e5750637a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-381c-76c8-a538-0b9e5750637a",
        "storage_key": "property/5694569974857728/019f150f-381c-76c8-a538-0b9e5750637a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJKTscFt4R3ogRjDS-f56vJwE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "ec_f013500b06a3ca8b8f0e58f6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "source": "generator",
      "poi_name": "Melbourne Square",
      "poi_type": "Transportation & Transit",
      "poi_address": "1700 W New Haven Ave, Melbourne, FL 32904, USA",
      "poi_short_description": "Department stores & a food court anchor an enclosed shopping mall with clothing, gift & kids' shops.",
      "poi_long_description": "Department stores & a food court anchor an enclosed shopping mall with clothing, gift & kids' shops.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f150e-5f54-74bf-a4d4-e17249e3665d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-5f54-74bf-a4d4-e17249e3665d",
        "storage_key": "property/5694569974857728/019f150e-5f54-74bf-a4d4-e17249e3665d.webp",
        "width": 1280,
        "height": 754
      },
      "poi_business_url": "https://melbournesquare.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11827943226429731958&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "melbourne-square",
      "poi_latitude": "28.0815186",
      "poi_longitude": "-80.64978049999999",
      "poi_miles_from_property": "6.2 mi",
      "poi_walking_minutes": "2 hours 17 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 321-727-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f150f-3837-7012-a605-c0255b9aa378.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-3837-7012-a605-c0255b9aa378",
        "storage_key": "property/5694569974857728/019f150f-3837-7012-a605-c0255b9aa378.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJayULcgwO3ogRdvTUgrJLJaQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_81f8e05b7ef6efba327b9f14",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "source": "generator",
      "poi_name": "The Avenue Viera",
      "poi_type": "Transportation & Transit",
      "poi_address": "2261 Town Center Ave, Melbourne, FL 32940, USA",
      "poi_short_description": "Open-air mall with name-brand stores & restaurants, plus a 16-screen cinema & a fountain.",
      "poi_long_description": "Open-air mall with name-brand stores & restaurants, plus a 16-screen cinema & a fountain.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f1510-f5f0-766f-b6f1-379aa1cfe59a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1510-f5f0-766f-b6f1-379aa1cfe59a",
        "storage_key": "property/5694569974857728/019f1510-f5f0-766f-b6f1-379aa1cfe59a.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.avenueviera.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16254149113957679415&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-avenue-viera",
      "poi_latitude": "28.2444297",
      "poi_longitude": "-80.7262058",
      "poi_miles_from_property": "9.8 mi",
      "poi_walking_minutes": "3 hours 35 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 321-634-5390",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f150f-3837-7012-a605-c0255b9aa378.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-3837-7012-a605-c0255b9aa378",
        "storage_key": "property/5694569974857728/019f150f-3837-7012-a605-c0255b9aa378.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJC7ncCqEG3ogRN4GtP4BWkuE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_3fad596ff471545d55f07302",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "source": "generator",
      "poi_name": "Viera Regional Park",
      "poi_type": "Transportation & Transit",
      "poi_address": "Viera West, FL 32940, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f1510-f5d1-7234-a0df-fd18b3c4070d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1510-f5d1-7234-a0df-fd18b3c4070d",
        "storage_key": "property/5694569974857728/019f1510-f5d1-7234-a0df-fd18b3c4070d.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=15025930832291834465&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "viera-regional-park",
      "poi_latitude": "28.2488656",
      "poi_longitude": "-80.7282954",
      "poi_miles_from_property": "10.1 mi",
      "poi_walking_minutes": "3 hours 41 mins",
      "poi_biking_minutes": "52 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f150f-381c-76c8-a538-0b9e5750637a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-381c-76c8-a538-0b9e5750637a",
        "storage_key": "property/5694569974857728/019f150f-381c-76c8-a538-0b9e5750637a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVae3OKQG3ogRYSpYLnvUhtA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "ec_a338851b352c15f50b870722",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "source": "generator",
      "poi_name": "L3Harris Technologies Corporate Headquarters",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1025 W NASA Blvd Bldg A, Melbourne, FL 32919, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f1510-f7df-714f-b765-ef32d595e9a1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1510-f7df-714f-b765-ef32d595e9a1",
        "storage_key": "property/5694569974857728/019f1510-f7df-714f-b765-ef32d595e9a1.webp",
        "width": 1280,
        "height": 622
      },
      "poi_business_url": "http://www.l3harris.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9762691640534636460&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "l3harris-technologies-corporate-headquarters",
      "poi_latitude": "28.0923174",
      "poi_longitude": "-80.637964",
      "poi_miles_from_property": "6.1 mi",
      "poi_walking_minutes": "2 hours 14 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 321-727-9100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f150f-381c-76c8-a538-0b9e5750637a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-381c-76c8-a538-0b9e5750637a",
        "storage_key": "property/5694569974857728/019f150f-381c-76c8-a538-0b9e5750637a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8dSUm_gP3ogRrBe-dVIMfIc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "ec_c76dcfc6c4c3570bcaa00b79",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "source": "generator",
      "poi_name": "NORTHROP GRUMMAN",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2000 W NASA Blvd, Melbourne, FL 32904, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://northropgrumman.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16422209183934606948&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "northrop-grumman",
      "poi_latitude": "28.0974835",
      "poi_longitude": "-80.6505746",
      "poi_miles_from_property": "5.8 mi",
      "poi_walking_minutes": "2 hours 6 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 321-951-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f150f-381c-76c8-a538-0b9e5750637a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-381c-76c8-a538-0b9e5750637a",
        "storage_key": "property/5694569974857728/019f150f-381c-76c8-a538-0b9e5750637a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJDZz1b2gO3ogRZG6Ugz5o5-M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "ec_acd3f65af1b1ea06b36c0173",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "source": "generator",
      "poi_name": "Florida Institute of Technology",
      "poi_type": "Major Employers & Offices",
      "poi_address": "150 W University Blvd, Melbourne, FL 32901, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f1510-fa33-7189-87f6-2fe668065866.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1510-fa33-7189-87f6-2fe668065866",
        "storage_key": "property/5694569974857728/019f1510-fa33-7189-87f6-2fe668065866.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.floridatech.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4015618102034841365&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "florida-institute-of-technology",
      "poi_latitude": "28.0639632",
      "poi_longitude": "-80.621455",
      "poi_miles_from_property": "7.7 mi",
      "poi_walking_minutes": "2 hours 49 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 321-674-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f150f-37ef-74de-abb7-2b8044b418ed.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-37ef-74de-abb7-2b8044b418ed",
        "storage_key": "property/5694569974857728/019f150f-37ef-74de-abb7-2b8044b418ed.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ96ZS_AQS3ogRFT9qXWNXujc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_9158d23580a91004200842b7",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "source": "generator",
      "poi_name": "Health First's Holmes Regional Medical Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1350 Hickory St, Melbourne, FL 32901, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f150e-ce02-77ab-8d04-dd9cce872e79.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-ce02-77ab-8d04-dd9cce872e79",
        "storage_key": "property/5694569974857728/019f150e-ce02-77ab-8d04-dd9cce872e79.webp",
        "width": 1280,
        "height": 843
      },
      "poi_business_url": "https://hf.org/healthcare-home/location-directory/holmes-regional-medical-center#about-this-location-",
      "poi_directions_map_url": "https://maps.google.com/?cid=12601849543310100390&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "health-firsts-holmes-regional-medical-center",
      "poi_latitude": "28.0874342",
      "poi_longitude": "-80.6143731",
      "poi_miles_from_property": "6.2 mi",
      "poi_walking_minutes": "2 hours 17 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 321-434-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f150f-3834-73b2-b0fa-763d96e43488.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-3834-73b2-b0fa-763d96e43488",
        "storage_key": "property/5694569974857728/019f150f-3834-73b2-b0fa-763d96e43488.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJh-lRY-wR3ogRpsfqZWTD4q4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "ec_5d0e25c6548bee38f8271021",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "source": "generator",
      "poi_name": "Eastern Florida State College - Melbourne Campus",
      "poi_type": "Major Employers & Offices",
      "poi_address": "3865 N Wickham Rd, Melbourne, FL 32935, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f150e-77a7-7251-bea4-77ea21aef907.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-77a7-7251-bea4-77ea21aef907",
        "storage_key": "property/5694569974857728/019f150e-77a7-7251-bea4-77ea21aef907.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.easternflorida.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6372378352007033922&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "eastern-florida-state-college---melbourne-campus",
      "poi_latitude": "28.169954",
      "poi_longitude": "-80.6708733",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 321-632-1111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f150f-37ef-74de-abb7-2b8044b418ed.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-37ef-74de-abb7-2b8044b418ed",
        "storage_key": "property/5694569974857728/019f150f-37ef-74de-abb7-2b8044b418ed.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJc0YBfn4F3ogRQrTETVk8b1g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_ab12e22ac0c07dfdf23a1df2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "source": "generator",
      "poi_name": "Melbourne Orlando International Airport",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1 Air Terminal Pkwy, Melbourne, FL 32901, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f150e-ee69-76bf-830b-4b58449430d9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-ee69-76bf-830b-4b58449430d9",
        "storage_key": "property/5694569974857728/019f150e-ee69-76bf-830b-4b58449430d9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.mlbair.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10996310418774269143&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "melbourne-orlando-international-airport",
      "poi_latitude": "28.1012659",
      "poi_longitude": "-80.645078",
      "poi_miles_from_property": "6.3 mi",
      "poi_walking_minutes": "2 hours 17 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 321-723-6227",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f150f-3ad9-720e-9826-31e296e1ba5c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-3ad9-720e-9826-31e296e1ba5c",
        "storage_key": "property/5694569974857728/019f150f-3ad9-720e-9826-31e296e1ba5c.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJtzLs29gR3ogR15z3nhC-mpg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "ec_f6daadf814ee30e76cf0ab3e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "source": "generator",
      "poi_name": "Terran Orbital Corporation",
      "poi_type": "Major Employers & Offices",
      "poi_address": "100 Rialto Pl 2nd Floor, Melbourne, FL 32901, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://terranorbital.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10765877833742962024&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "terran-orbital-corporation",
      "poi_latitude": "28.0900697",
      "poi_longitude": "-80.6251468",
      "poi_miles_from_property": "6.0 mi",
      "poi_walking_minutes": "2 hours 11 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 855-862-5527",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f150f-381c-76c8-a538-0b9e5750637a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-381c-76c8-a538-0b9e5750637a",
        "storage_key": "property/5694569974857728/019f150f-381c-76c8-a538-0b9e5750637a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJY5SfE6UR3ogRaE2Ah9kUaJU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "ec_e8f76c03b12cefd4fd3f112f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "source": "generator",
      "poi_name": "Melbourne City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "900 E Strawbridge Ave, Melbourne, FL 32901, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f150e-f18f-70bd-aeea-f00592df5bb0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-f18f-70bd-aeea-f00592df5bb0",
        "storage_key": "property/5694569974857728/019f150e-f18f-70bd-aeea-f00592df5bb0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.melbourneflorida.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1804643251473235003&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "melbourne-city-hall",
      "poi_latitude": "28.0797943",
      "poi_longitude": "-80.6067676",
      "poi_miles_from_property": "7.1 mi",
      "poi_walking_minutes": "2 hours 37 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 321-608-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f150f-37eb-75ee-967b-0e6a2d583ed1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-37eb-75ee-967b-0e6a2d583ed1",
        "storage_key": "property/5694569974857728/019f150f-37eb-75ee-967b-0e6a2d583ed1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6w_8s40R3ogROzxeznlhCxk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "ec_e4933dad8811fa183830b59e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "source": "generator",
      "poi_name": "Brevard County Tax Collector Viera Branch",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2725 Judge Fran Jamieson Way A108, Melbourne, FL 32940, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f1510-fb0c-7754-91e5-2755192bd73c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1510-fb0c-7754-91e5-2755192bd73c",
        "storage_key": "property/5694569974857728/019f1510-fb0c-7754-91e5-2755192bd73c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.brevardtaxcollector.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6511526447070835714&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "brevard-county-tax-collector-viera-branch",
      "poi_latitude": "28.2467159",
      "poi_longitude": "-80.7369157",
      "poi_miles_from_property": "10.7 mi",
      "poi_walking_minutes": "3 hours 54 mins",
      "poi_biking_minutes": "54 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 321-633-2199",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f150f-37eb-75ee-967b-0e6a2d583ed1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-37eb-75ee-967b-0e6a2d583ed1",
        "storage_key": "property/5694569974857728/019f150f-37eb-75ee-967b-0e6a2d583ed1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJfUhFFLwG3ogRAvQ3182WXVo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    },
    {
      "id": "ec_838a86f0b5e3e94564808837",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "source": "generator",
      "poi_name": "Brevard County School District",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2700 Judge Fran Jamieson Way, Melbourne, FL 32940, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f1510-fbb1-75f5-9569-617618e2e54e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1510-fbb1-75f5-9569-617618e2e54e",
        "storage_key": "property/5694569974857728/019f1510-fbb1-75f5-9569-617618e2e54e.webp",
        "width": 1280,
        "height": 606
      },
      "poi_business_url": "https://www.brevardschools.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11185409754570738002&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "brevard-county-school-district",
      "poi_latitude": "28.2482265",
      "poi_longitude": "-80.7366206",
      "poi_miles_from_property": "10.6 mi",
      "poi_walking_minutes": "3 hours 51 mins",
      "poi_biking_minutes": "55 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 321-633-1000 ext. 796",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f150f-37ef-74de-abb7-2b8044b418ed.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-37ef-74de-abb7-2b8044b418ed",
        "storage_key": "property/5694569974857728/019f150f-37ef-74de-abb7-2b8044b418ed.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJl-LOkLsG3ogRUslgsOiOOps",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    }
  ],
  "office_hours": [
    {
      "id": "custom_a68e5713-d655-40e7-aac1-d3492a90b894",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_55b7822f-c73a-454e-9737-ec1b03d67ac2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_51d33b96-a27b-448a-bd8a-419dd1fa5235",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_ce444567-2064-45a6-9861-81627387b385",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_cc41256d-e32b-4a7e-9da8-302c577bdc7d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_5ce028f2-1231-4d24-bcee-dc7ebc018976",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_14ea3516-6ae6-4534-9119-7ac37b329cb2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "rating": "5.0",
      "name": "Sweet Lovinn",
      "text": "The leasing office staff is knowledgeable and friendly, and the maintenance team works hard to complete any requests in a timely manner. It’s nice to see a staff who shows that they care for their residents!!",
      "date": "2026-06-03",
      "title": ""
    },
    {
      "id": "custom_e8adbb88-41df-4ed2-b6dd-815c72fde20a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "rating": "5.0",
      "name": "Pablo Rivera",
      "text": "I had great experience with Vanessa and team at City Harbor apartments! I was in need of an apartment rush and they made it happen. Also when I wanted to change my shower head they took action quickly.",
      "date": "2026-05-14",
      "title": ""
    },
    {
      "id": "custom_58916c3e-29a7-402d-a315-54eac67dbac4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "rating": "5.0",
      "name": "Javi Activao",
      "text": "I recently moved in to City Harbor apartments. Daiana helped me to complete all the required paper work in advance before the move to make it a smooth process. Upon arrival to City Harbor apartments, Daiana had the unit clean and ready for me to move in. I'm very happy that I choose City Harbor as my living residence in Melbourne, Florida; since its gardens, swimming pool, tranquility and STAFF make me feel that I'm really living on a resort.",
      "date": "2022-09-23",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "ec_89615e1e11d8f02510868500",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "source": "generator",
      "url_health_error": "false",
      "virtual_tour_description": "YouTube channel: American Landmark",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f14c4-9237-7238-b6ae-4fb76d9735e7.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f14c4-9237-7238-b6ae-4fb76d9735e7",
        "storage_key": "property/5694569974857728/019f14c4-9237-7238-b6ae-4fb76d9735e7.webp",
        "width": 480,
        "height": 360
      },
      "virtual_tour_title": "City Harbor - Community Tour",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://www.youtube.com/embed/trQvmKr-cUY"
    }
  ],
  "faqs": [
    {
      "id": "custom_e2dec3c9-03e7-4638-80f2-d8e3072088ad",
      "question": "Is City Harbor pet-friendly?",
      "answer": "Yes. City Harbor welcomes cats and dogs, up to 2 pets per home, with no posted weight limit. Some breed restrictions apply. Assistance animals (service animals and emotional support animals) are not pets under fair housing law, so they are not subject to pet fees, deposits, or breed and weight restrictions. For the full pet policy, call the leasing team at (321) 242-9191 or visit our contact page.",
      "category": "Pet Policy",
      "source": "custom"
    },
    {
      "id": "custom_670f5df2-7211-4242-8576-4ad265165930",
      "question": "How can I schedule a tour at City Harbor?",
      "answer": "You can schedule a tour of City Harbor online through our Schedule a Tour page, or call the leasing office at (321) 242-9191. You can also view our virtual tours to see the community before visiting in person.",
      "category": "Contact & Tours",
      "source": "custom"
    },
    {
      "id": "custom_605cc15c-40c3-402b-8b4a-c88be93c9337",
      "question": "What are the leasing office hours at City Harbor?",
      "answer": "The City Harbor leasing office is open during these hours:\n\n• Monday: 9:00 AM to 6:00 PM\n• Tuesday: 9:00 AM to 6:00 PM\n• Wednesday: 9:00 AM to 6:00 PM\n• Thursday: 9:00 AM to 6:00 PM\n• Friday: 9:00 AM to 6:00 PM\n• Saturday: 10:00 AM to 5:00 PM\n\nHours may change around holidays. Call (321) 242-9191 or visit our contact page to confirm before you visit.",
      "category": "Office Hours",
      "source": "custom"
    },
    {
      "id": "custom_af1a6f75-9f0d-4f3e-88ba-4306dffb3531",
      "question": "What floor plans are available at City Harbor?",
      "answer": "City Harbor offers 1- to 3-bedroom apartment homes ranging from approximately 700 to 1,025 square feet, across 3 floor plans. View layouts, square footage, and current availability on our Floor Plans page, or schedule a tour to see them in person.",
      "category": "Floor Plans & Units",
      "source": "custom"
    },
    {
      "id": "custom_f51c6e97-2d4e-4226-8a5c-dc0c44b1fb32",
      "question": "What amenities does City Harbor have?",
      "answer": "City Harbor offers a range of community and in-home amenities. Community amenities include: Resort‑Inspired Pool w/ Cabanas, Outdoor Kitchen w/ Gas Grills, Modern Fitness Center w/ Workout Mirror, Resident Entertainment Room, Wi‑Fi Available at Pool, Credit Building Services Powered by RentPlus, Concierge Cleaning Services Available by Spruce, Convenient 24/7 Online Resident Services, and American Landmark 360 Resident Program. In-home features include: stainless‑steel appliances, sleek granite countertops, in‑home washer & dryer*, decorative kitchen backsplash, wood style flooring, and 9' ceilings. See the complete list on our Amenities page.",
      "category": "Amenities & Features",
      "source": "custom"
    },
    {
      "id": "custom_fd7aae9b-9ccb-4ec8-bec9-bd785a0f3061",
      "question": "Where is City Harbor located?",
      "answer": "City Harbor is located at 2395 Woodwind Trail, Melbourne FL 32935. Nearby you'll find dining at Frigate's Waterfront Bar & Grill - Melbourne, shopping at ALDI, and green space at Wickham Park. Explore more on our Neighborhood page.",
      "category": "Location & Neighborhood",
      "source": "custom"
    },
    {
      "id": "custom_bf109455-7793-409c-8d94-03716e266ad4",
      "question": "How do I apply to live at City Harbor?",
      "answer": "You can apply to live at City Harbor online through our Apply Now page, which walks you through each step. If you have questions, the leasing team can help. Call (321) 242-9191 or reach out through our contact page.",
      "category": "Application Process",
      "source": "custom"
    },
    {
      "id": "custom_b2e4b3f0-e0fd-498a-a9c8-a1820f28289b",
      "question": "What do I need to apply at City Harbor?",
      "answer": "Applicants should be ready to provide standard rental application information, including government-issued identification, proof of income, and rental history. Qualification requirements can vary, so we recommend confirming the current criteria with the City Harbor leasing team at (321) 242-9191 or on our contact page. When you're ready, start on the Apply Now page.",
      "category": "Application Process",
      "source": "custom"
    },
    {
      "id": "custom_9c636e61-fcb7-4609-8f89-27340aee41fb",
      "question": "What is the Landmark 360 program at City Harbor?",
      "answer": "City Harbor participates in American Landmark's Landmark 360 resident program, which includes three resident promises:\n\n• Move-In Satisfaction Promise: if you are not satisfied within your first 15 days, American Landmark will refund your deposit and waive lease-termination fees.\n• 48-Hour Maintenance Completion Promise: work orders are completed within 48 hours (Monday through Friday), with rent credits if that timeline is missed.\n• Relocation Promise: after six months on your lease, you can transfer to another American Landmark community without penalties, with 60 days' written notice.\nTo learn more, contact the leasing team at (321) 242-9191 or visit our contact page.",
      "category": "Resident Programs",
      "source": "custom"
    },
    {
      "id": "custom_360073ce-4a8d-4c4b-854a-48477b090b38",
      "question": "Does City Harbor have a pool?",
      "answer": "Yes. City Harbor has a swimming pool for residents. See it alongside our other community amenities on the Amenities page.",
      "category": "Amenities & Features",
      "source": "custom"
    },
    {
      "id": "custom_a17ad345-dab6-4789-8f86-0c6f1af6285f",
      "question": "Does City Harbor have a fitness center?",
      "answer": "Yes. City Harbor has a 24-hour fitness center available to residents at any time. See all amenities on the Amenities page, or schedule a tour to view it in person.",
      "category": "Amenities & Features",
      "source": "custom"
    },
    {
      "id": "custom_31d73af0-639c-4702-af42-9349e6741979",
      "question": "Does City Harbor offer virtual tours?",
      "answer": "Yes. City Harbor offers virtual tours of City Harbor - Community Tour. Start on our Virtual Tours page, then schedule an in-person tour when you are ready.",
      "category": "Contact & Tours",
      "source": "custom"
    },
    {
      "id": "custom_b2f1be02-a80c-490e-8a9d-492cc17605ee",
      "question": "What do residents say about living at City Harbor?",
      "answer": "Residents frequently mention the helpful staff and responsive maintenance at City Harbor. One resident wrote: *\"The leasing office staff is knowledgeable and friendly, and the maintenance team works hard to complete any requests in a timely manner. It’s nice to see a staff who shows that they care for their residents!!\"* Read more resident reviews on our Reviews page.",
      "category": "Resident Life",
      "source": "custom"
    },
    {
      "id": "custom_201fa842-6d79-4a25-9059-473e7839803f",
      "question": "When was City Harbor built?",
      "answer": "City Harbor was built in 1987 and renovated in 2022. Schedule a tour to see the finishes in person.",
      "category": "Property History & Features",
      "source": "custom"
    },
    {
      "id": "custom_4bab2825-dd21-4cd1-9e73-457b74360e60",
      "question": "What is the pet fee at City Harbor?",
      "answer": "Pets at City Harbor: cats and dogs are welcome, up to 2 per home, with no posted weight limit. Some breed restrictions apply. Assistance animals (service animals and emotional support animals) are not pets under fair housing law, so they are not subject to pet fees, deposits, or breed and weight restrictions. For details, contact the leasing team at (321) 242-9191 or visit our contact page.",
      "category": "Pet Policy",
      "source": "custom"
    },
    {
      "id": "custom_71cd7e1d-c7d5-4dc0-a461-96070a28ceb5",
      "question": "What features are included in the apartments at City Harbor?",
      "answer": "Apartment homes at City Harbor include stainless‑steel appliances, sleek granite countertops, in‑home washer & dryer*, decorative kitchen backsplash, wood style flooring, and 9' ceilings. Browse layouts on our Floor Plans page or schedule a tour.",
      "category": "Amenities & Features",
      "source": "custom"
    },
    {
      "id": "custom_f2a060bc-1a74-4aa2-8aa0-69c27af17eb8",
      "question": "What restaurants and shops are near City Harbor?",
      "answer": "Nearby restaurants and shops include Frigate's Waterfront Bar & Grill - Melbourne, Bacco Wine Cafe, Meg O’Malley's Restaurant & Irish Pub, and Moon River Cafe & Curiosities. See the full neighborhood guide on our Neighborhood page.",
      "category": "Location & Neighborhood",
      "source": "custom"
    }
  ],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "0198aa45-4d68-7297-b13f-0ed26f0ac089",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "city-harbor",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728"
    },
    {
      "lead_collector_id": "0198aa45-4dcc-7095-b637-d142681f6eca",
      "lead_source": "FACEBOOK_ADS",
      "name": "city-harbor",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728"
    },
    {
      "lead_collector_id": "0198aa45-4e36-74d1-845e-98f1f4c03e8e",
      "lead_source": "LANDING_PAGE",
      "name": "city-harbor",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "source": "custom",
      "page_item_url": "one-bedroom-apartments-for-rent-melbourne-fl-city-harbor",
      "search_query": "One Bedroom Apartments For Rent In Melbourne FL",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments For Rent In Melbourne FL at City Harbor",
      "h2_subtitle": "Discover upscale living in a pet-friendly community near Mallards Landing Golf Course. Enjoy resort-style amenities and modern apartment features.",
      "page_copy": "Escape the ordinary and settle into something special with our one bedroom apartments for rent in Melbourne FL at City Harbor. Our upscale community near Mallards Landing Golf Course features a quiet, park-like setting with its own private lake, secured VIP access, and resort-style amenities including a beautiful swimming pool and a fully equipped fitness center. Each one bedroom apartment is designed with the finest features and finishes, including sleek granite countertops, stainless-steel appliances, and wood-style flooring in select homes. Enjoy a cozy sunroom area perfect for reading, working, or relaxing. Set sail for Melbourne and discover how good home can be at City Harbor.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f6c0d-69ab-702b-abde-fa9c45615d04.webp",
      "featured_image_media": {
        "alt_text": "Outdoor seating area with blue upholstered furniture and umbrellas overlooking a lake with a fountain.",
        "public_id": "019f6c0d-69ab-702b-abde-fa9c45615d04",
        "storage_key": "property/5694569974857728/019f6c0d-69ab-702b-abde-fa9c45615d04.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f6c0d-73a2-74ea-a915-c4d3d5575d0d.webp",
      "blank_image_media": {
        "alt_text": "Exterior of apartment building with a pool and lounge chairs.",
        "public_id": "019f6c0d-73a2-74ea-a915-c4d3d5575d0d",
        "storage_key": "property/5694569974857728/019f6c0d-73a2-74ea-a915-c4d3d5575d0d.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "City Harbor | One Bedroom Apartments For Rent In Melbourne FL",
      "seo_description": "Find one bedroom apartments for rent in Melbourne FL at City Harbor. Enjoy modern features, resort-style amenities, and a pet-friendly community near Mallards Landing Golf Course.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "source": "custom",
      "page_item_url": "two-bedrooms-apartments-for-rent-melbourne-fl-city-harbor",
      "search_query": "Two Bedrooms Apartments For Rent In Melbourne FL",
      "category": "Floorplan",
      "h1_title": "Two Bedrooms Apartments For Rent In Melbourne FL at City Harbor",
      "h2_subtitle": "Experience luxury living in a pet-friendly community near Mallards Landing Golf Course. Enjoy resort-style amenities and modern apartment features.",
      "page_copy": "Escape the ordinary and settle into something special with our two bedrooms apartments for rent in Melbourne FL at City Harbor. Our upscale community near Mallards Landing Golf Course features a quiet, park-like setting with its own private lake, secured VIP access, and resort-style amenities including a beautiful swimming pool and a fully equipped fitness center. Each two bedroom apartment is designed with the finest features and finishes, including sleek granite countertops, stainless-steel appliances, and wood-style flooring in select homes. Enjoy a cozy sunroom area perfect for reading, working, or relaxing. Set sail for Melbourne and discover how good home can be at City Harbor.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f6c0d-69ab-702b-abde-fa9c45615d04.webp",
      "featured_image_media": {
        "alt_text": "Outdoor seating area with blue upholstered furniture and umbrellas overlooking a lake with a fountain.",
        "public_id": "019f6c0d-69ab-702b-abde-fa9c45615d04",
        "storage_key": "property/5694569974857728/019f6c0d-69ab-702b-abde-fa9c45615d04.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f6c0d-73a2-74ea-a915-c4d3d5575d0d.webp",
      "blank_image_media": {
        "alt_text": "Exterior of apartment building with a pool and lounge chairs.",
        "public_id": "019f6c0d-73a2-74ea-a915-c4d3d5575d0d",
        "storage_key": "property/5694569974857728/019f6c0d-73a2-74ea-a915-c4d3d5575d0d.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "City Harbor | Two Bedrooms Apartments For Rent In Melbourne FL",
      "seo_description": "Find two bedrooms apartments for rent in Melbourne FL at City Harbor. Enjoy modern features, resort-style amenities, and a pet-friendly community near Mallards Landing Golf Course.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "source": "custom",
      "page_item_url": "three-bedrooms-apartments-for-rent-melbourne-fl-city-harbor",
      "search_query": "Three Bedrooms Apartments For Rent In Melbourne FL",
      "category": "Floorplan",
      "h1_title": "Three Bedrooms Apartments For Rent In Melbourne FL at City Harbor",
      "h2_subtitle": "Indulge in spacious living in a pet-friendly community near Mallards Landing Golf Course. Enjoy resort-style amenities and premium apartment features.",
      "page_copy": "Escape the ordinary and settle into something special with our three bedrooms apartments for rent in Melbourne FL at City Harbor. Our upscale community near Mallards Landing Golf Course features a quiet, park-like setting with its own private lake, secured VIP access, and resort-style amenities including a beautiful swimming pool and a fully equipped fitness center. Each three bedroom apartment is designed with the finest features and finishes, including sleek granite countertops, stainless-steel appliances, and wood-style flooring in select homes. Enjoy a cozy sunroom area perfect for reading, working, or relaxing. Set sail for Melbourne and discover how good home can be at City Harbor.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f6c0d-69ab-702b-abde-fa9c45615d04.webp",
      "featured_image_media": {
        "alt_text": "Outdoor seating area with blue upholstered furniture and umbrellas overlooking a lake with a fountain.",
        "public_id": "019f6c0d-69ab-702b-abde-fa9c45615d04",
        "storage_key": "property/5694569974857728/019f6c0d-69ab-702b-abde-fa9c45615d04.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f6c0d-73a2-74ea-a915-c4d3d5575d0d.webp",
      "blank_image_media": {
        "alt_text": "Exterior of apartment building with a pool and lounge chairs.",
        "public_id": "019f6c0d-73a2-74ea-a915-c4d3d5575d0d",
        "storage_key": "property/5694569974857728/019f6c0d-73a2-74ea-a915-c4d3d5575d0d.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "City Harbor | Three Bedrooms Apartments For Rent In Melbourne FL",
      "seo_description": "Find three bedrooms apartments for rent in Melbourne FL at City Harbor. Enjoy modern features, resort-style amenities, and a pet-friendly community near Mallards Landing Golf Course.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "source": "custom",
      "page_item_url": "apartments-for-rent-near-me-resort-inspired-pool-city-harbor",
      "search_query": "Apartments For Rent Near Me with Resort-Inspired Pool w/ Cabanas",
      "category": "Amenity",
      "h1_title": "Apartments For Rent Near Me with Resort-Inspired Pool w/ Cabanas at City Harbor",
      "h2_subtitle": "Experience luxury living in a pet-friendly community near Mallards Landing Golf Course. Enjoy resort-style amenities and modern apartment features.",
      "page_copy": "Escape the ordinary and settle into something special with our apartments for rent near me with resort-inspired pool w/ cabanas at City Harbor. Our upscale Melbourne, Florida, apartment community near Mallards Landing Golf Course features a quiet, park-like setting with its own private lake, secured VIP access, and resort-style amenities including a beautiful swimming pool with cabanas and a fully equipped fitness center. Each apartment is designed with the finest features and finishes, including sleek granite countertops, stainless-steel appliances, and wood-style flooring in select homes. Enjoy a cozy sunroom area perfect for reading, working, or relaxing. Set sail for Melbourne and discover how good home can be at City Harbor.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f6c0d-69ab-702b-abde-fa9c45615d04.webp",
      "featured_image_media": {
        "alt_text": "Outdoor seating area with blue upholstered furniture and umbrellas overlooking a lake with a fountain.",
        "public_id": "019f6c0d-69ab-702b-abde-fa9c45615d04",
        "storage_key": "property/5694569974857728/019f6c0d-69ab-702b-abde-fa9c45615d04.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f6c0d-73a2-74ea-a915-c4d3d5575d0d.webp",
      "blank_image_media": {
        "alt_text": "Exterior of apartment building with a pool and lounge chairs.",
        "public_id": "019f6c0d-73a2-74ea-a915-c4d3d5575d0d",
        "storage_key": "property/5694569974857728/019f6c0d-73a2-74ea-a915-c4d3d5575d0d.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "City Harbor | Apartments For Rent Near Me with Resort-Inspired Pool w/ Cabanas",
      "seo_description": "Find apartments for rent near me with resort-inspired pool w/ cabanas at City Harbor. Enjoy modern features, resort-style amenities, and a pet-friendly community near Mallards Landing Golf Course.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "source": "custom",
      "page_item_url": "apartments-for-rent-near-me-modern-fitness-center-city-harbor",
      "search_query": "Apartments For Rent Near Me with Modern Fitness Center w/ Workout Mirror",
      "category": "Amenity",
      "h1_title": "Apartments For Rent Near Me with Modern Fitness Center w/ Workout Mirror at City Harbor",
      "h2_subtitle": "Discover upscale living in a pet-friendly community near Mallards Landing Golf Course. Enjoy resort-style amenities and modern apartment features.",
      "page_copy": "Escape the ordinary and settle into something special with our apartments for rent near me with modern fitness center w/ workout mirror at City Harbor. Our upscale Melbourne, Florida, apartment community near Mallards Landing Golf Course features a quiet, park-like setting with its own private lake, secured VIP access, and resort-style amenities including a beautiful swimming pool and a fully equipped fitness center with a workout mirror. Each apartment is designed with the finest features and finishes, including sleek granite countertops, stainless-steel appliances, and wood-style flooring in select homes. Enjoy a cozy sunroom area perfect for reading, working, or relaxing. Set sail for Melbourne and discover how good home can be at City Harbor.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f6c0d-69ab-702b-abde-fa9c45615d04.webp",
      "featured_image_media": {
        "alt_text": "Outdoor seating area with blue upholstered furniture and umbrellas overlooking a lake with a fountain.",
        "public_id": "019f6c0d-69ab-702b-abde-fa9c45615d04",
        "storage_key": "property/5694569974857728/019f6c0d-69ab-702b-abde-fa9c45615d04.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f6c0d-73a2-74ea-a915-c4d3d5575d0d.webp",
      "blank_image_media": {
        "alt_text": "Exterior of apartment building with a pool and lounge chairs.",
        "public_id": "019f6c0d-73a2-74ea-a915-c4d3d5575d0d",
        "storage_key": "property/5694569974857728/019f6c0d-73a2-74ea-a915-c4d3d5575d0d.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "City Harbor | Apartments For Rent Near Me with Modern Fitness Center w/ Workout Mirror",
      "seo_description": "Find apartments for rent near me with modern fitness center w/ workout mirror at City Harbor. Enjoy modern features, resort-style amenities, and a pet-friendly community near Mallards Landing Golf Course.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "source": "custom",
      "page_item_url": "apartments-for-rent-near-melbourne-regional-med-center",
      "search_query": "Apartments For Rent In Melbourne FL Near Melbourne Regional Medical Center",
      "category": "POI",
      "h1_title": "Apartments For Rent In Melbourne FL Near Melbourne Regional Medical Center at City Harbor",
      "h2_subtitle": "Discover upscale living in a pet-friendly community near Mallards Landing Golf Course. Enjoy resort-style amenities and modern apartment features.",
      "page_copy": "Escape the ordinary and settle into something special with our apartments for rent in Melbourne FL near Melbourne Regional Medical Center at City Harbor. Our upscale Melbourne, Florida, apartment community near Mallards Landing Golf Course features a quiet, park-like setting with its own private lake, secured VIP access, and resort-style amenities including a beautiful swimming pool and a fully equipped fitness center. Each apartment is designed with the finest features and finishes, including sleek granite countertops, stainless-steel appliances, and wood-style flooring in select homes. Enjoy a cozy sunroom area perfect for reading, working, or relaxing. Set sail for Melbourne and discover how good home can be at City Harbor.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f6c0d-69ab-702b-abde-fa9c45615d04.webp",
      "featured_image_media": {
        "alt_text": "Outdoor seating area with blue upholstered furniture and umbrellas overlooking a lake with a fountain.",
        "public_id": "019f6c0d-69ab-702b-abde-fa9c45615d04",
        "storage_key": "property/5694569974857728/019f6c0d-69ab-702b-abde-fa9c45615d04.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f6c0d-73a2-74ea-a915-c4d3d5575d0d.webp",
      "blank_image_media": {
        "alt_text": "Exterior of apartment building with a pool and lounge chairs.",
        "public_id": "019f6c0d-73a2-74ea-a915-c4d3d5575d0d",
        "storage_key": "property/5694569974857728/019f6c0d-73a2-74ea-a915-c4d3d5575d0d.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "City Harbor | Apartments For Rent In Melbourne FL Near Melbourne Regional Medical Center",
      "seo_description": "Find apartments for rent in Melbourne FL near Melbourne Regional Medical Center at City Harbor. Enjoy modern features, resort-style amenities, and a pet-friendly community near Mallards Landing Golf Course.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "source": "custom",
      "page_item_url": "apartments-for-rent-melbourne-fl-near-viera-hospital",
      "search_query": "Apartments For Rent In Melbourne FL Near Health First's Viera Hospital",
      "category": "POI",
      "h1_title": "Apartments For Rent In Melbourne FL Near Health First's Viera Hospital at City Harbor",
      "h2_subtitle": "Discover upscale living in a pet-friendly community near Mallards Landing Golf Course. Enjoy resort-style amenities and modern apartment features.",
      "page_copy": "Escape the ordinary and settle into something special with our apartments for rent in Melbourne FL near Health First's Viera Hospital at City Harbor. Our upscale Melbourne, Florida, apartment community near Mallards Landing Golf Course features a quiet, park-like setting with its own private lake, secured VIP access, and resort-style amenities including a beautiful swimming pool and a fully equipped fitness center. Each apartment is designed with the finest features and finishes, including sleek granite countertops, stainless-steel appliances, and wood-style flooring in select homes. Enjoy a cozy sunroom area perfect for reading, working, or relaxing. Set sail for Melbourne and discover how good home can be at City Harbor.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f6c0d-69ab-702b-abde-fa9c45615d04.webp",
      "featured_image_media": {
        "alt_text": "Outdoor seating area with blue upholstered furniture and umbrellas overlooking a lake with a fountain.",
        "public_id": "019f6c0d-69ab-702b-abde-fa9c45615d04",
        "storage_key": "property/5694569974857728/019f6c0d-69ab-702b-abde-fa9c45615d04.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f6c0d-73a2-74ea-a915-c4d3d5575d0d.webp",
      "blank_image_media": {
        "alt_text": "Exterior of apartment building with a pool and lounge chairs.",
        "public_id": "019f6c0d-73a2-74ea-a915-c4d3d5575d0d",
        "storage_key": "property/5694569974857728/019f6c0d-73a2-74ea-a915-c4d3d5575d0d.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "City Harbor | Apartments For Rent In Melbourne FL Near Health First's Viera Hospital",
      "seo_description": "Find apartments for rent in Melbourne FL near Health First's Viera Hospital at City Harbor. Enjoy modern features, resort-style amenities, and a pet-friendly community near Mallards Landing Golf Course.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "source": "custom",
      "page_item_url": "apartments-for-rent-near-kindred-hospital-melbourne",
      "search_query": "Apartments For Rent In Melbourne FL Near Kindred Hospital Melbourne",
      "category": "POI",
      "h1_title": "Apartments For Rent In Melbourne FL Near Kindred Hospital Melbourne at City Harbor",
      "h2_subtitle": "Discover upscale living in a pet-friendly community near Mallards Landing Golf Course. Enjoy resort-style amenities and modern apartment features.",
      "page_copy": "Escape the ordinary and settle into something special with our apartments for rent in Melbourne FL near Kindred Hospital Melbourne at City Harbor. Our upscale Melbourne, Florida, apartment community near Mallards Landing Golf Course features a quiet, park-like setting with its own private lake, secured VIP access, and resort-style amenities including a beautiful swimming pool and a fully equipped fitness center. Each apartment is designed with the finest features and finishes, including sleek granite countertops, stainless-steel appliances, and wood-style flooring in select homes. Enjoy a cozy sunroom area perfect for reading, working, or relaxing. Set sail for Melbourne and discover how good home can be at City Harbor.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f6c0d-69ab-702b-abde-fa9c45615d04.webp",
      "featured_image_media": {
        "alt_text": "Outdoor seating area with blue upholstered furniture and umbrellas overlooking a lake with a fountain.",
        "public_id": "019f6c0d-69ab-702b-abde-fa9c45615d04",
        "storage_key": "property/5694569974857728/019f6c0d-69ab-702b-abde-fa9c45615d04.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f6c0d-73a2-74ea-a915-c4d3d5575d0d.webp",
      "blank_image_media": {
        "alt_text": "Exterior of apartment building with a pool and lounge chairs.",
        "public_id": "019f6c0d-73a2-74ea-a915-c4d3d5575d0d",
        "storage_key": "property/5694569974857728/019f6c0d-73a2-74ea-a915-c4d3d5575d0d.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "City Harbor | Apartments For Rent In Melbourne FL Near Kindred Hospital Melbourne",
      "seo_description": "Find apartments for rent in Melbourne FL near Kindred Hospital Melbourne at City Harbor. Enjoy modern features, resort-style amenities, and a pet-friendly community near Mallards Landing Golf Course.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "source": "custom",
      "page_item_url": "apartments-for-rent-melbourne-fl-near-circles-care",
      "search_query": "Apartments For Rent In Melbourne FL Near Circles of Care",
      "category": "POI",
      "h1_title": "Apartments For Rent In Melbourne FL Near Circles of Care at City Harbor",
      "h2_subtitle": "Discover upscale living in a pet-friendly community near Mallards Landing Golf Course. Enjoy resort-style amenities and modern apartment features.",
      "page_copy": "Escape the ordinary and settle into something special with our apartments for rent in Melbourne FL near Circles of Care at City Harbor. Our upscale Melbourne, Florida, apartment community near Mallards Landing Golf Course features a quiet, park-like setting with its own private lake, secured VIP access, and resort-style amenities including a beautiful swimming pool and a fully equipped fitness center. Each apartment is designed with the finest features and finishes, including sleek granite countertops, stainless-steel appliances, and wood-style flooring in select homes. Enjoy a cozy sunroom area perfect for reading, working, or relaxing. Set sail for Melbourne and discover how good home can be at City Harbor.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f6c0d-69ab-702b-abde-fa9c45615d04.webp",
      "featured_image_media": {
        "alt_text": "Outdoor seating area with blue upholstered furniture and umbrellas overlooking a lake with a fountain.",
        "public_id": "019f6c0d-69ab-702b-abde-fa9c45615d04",
        "storage_key": "property/5694569974857728/019f6c0d-69ab-702b-abde-fa9c45615d04.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f6c0d-73a2-74ea-a915-c4d3d5575d0d.webp",
      "blank_image_media": {
        "alt_text": "Exterior of apartment building with a pool and lounge chairs.",
        "public_id": "019f6c0d-73a2-74ea-a915-c4d3d5575d0d",
        "storage_key": "property/5694569974857728/019f6c0d-73a2-74ea-a915-c4d3d5575d0d.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "City Harbor | Apartments For Rent In Melbourne FL Near Circles of Care",
      "seo_description": "Find apartments for rent in Melbourne FL near Circles of Care at City Harbor. Enjoy modern features, resort-style amenities, and a pet-friendly community near Mallards Landing Golf Course.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "source": "custom",
      "page_item_url": "apartments-for-rent-near-efsc-melbourne-campus",
      "search_query": "Apartments For Rent In Melbourne FL Near Eastern Florida State College - Melbourne Campus",
      "category": "POI",
      "h1_title": "Apartments For Rent In Melbourne FL Near Eastern Florida State College - Melbourne Campus at City Harbor",
      "h2_subtitle": "Discover upscale living in a pet-friendly community near Mallards Landing Golf Course. Enjoy resort-style amenities and modern apartment features.",
      "page_copy": "Escape the ordinary and settle into something special with our apartments for rent in Melbourne FL near Eastern Florida State College - Melbourne Campus at City Harbor. Our upscale Melbourne, Florida, apartment community near Mallards Landing Golf Course features a quiet, park-like setting with its own private lake, secured VIP access, and resort-style amenities including a beautiful swimming pool and a fully equipped fitness center. Each apartment is designed with the finest features and finishes, including sleek granite countertops, stainless-steel appliances, and wood-style flooring in select homes. Enjoy a cozy sunroom area perfect for reading, working, or relaxing. Set sail for Melbourne and discover how good home can be at City Harbor.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f6c0d-69ab-702b-abde-fa9c45615d04.webp",
      "featured_image_media": {
        "alt_text": "Outdoor seating area with blue upholstered furniture and umbrellas overlooking a lake with a fountain.",
        "public_id": "019f6c0d-69ab-702b-abde-fa9c45615d04",
        "storage_key": "property/5694569974857728/019f6c0d-69ab-702b-abde-fa9c45615d04.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f6c0d-73a2-74ea-a915-c4d3d5575d0d.webp",
      "blank_image_media": {
        "alt_text": "Exterior of apartment building with a pool and lounge chairs.",
        "public_id": "019f6c0d-73a2-74ea-a915-c4d3d5575d0d",
        "storage_key": "property/5694569974857728/019f6c0d-73a2-74ea-a915-c4d3d5575d0d.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "City Harbor | Apartments For Rent In Melbourne FL Near Eastern Florida State College - Melbourne Campus",
      "seo_description": "Find apartments for rent in Melbourne FL near Eastern Florida State College - Melbourne Campus at City Harbor. Enjoy modern features, resort-style amenities, and a pet-friendly community near Mallards Landing Golf Course.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "source": "custom",
      "page_item_url": "apartments-for-rent-near-geospace-lab-city-harbor",
      "search_query": "Apartments For Rent In Melbourne FL Near Geospace Physics Laboratory",
      "category": "POI",
      "h1_title": "Apartments For Rent In Melbourne FL Near Geospace Physics Laboratory at City Harbor",
      "h2_subtitle": "Discover upscale living in a pet-friendly community near Mallards Landing Golf Course. Enjoy resort-style amenities and modern apartment features.",
      "page_copy": "Escape the ordinary and settle into something special with our apartments for rent in Melbourne FL near Geospace Physics Laboratory at City Harbor. Our upscale Melbourne, Florida, apartment community near Mallards Landing Golf Course features a quiet, park-like setting with its own private lake, secured VIP access, and resort-style amenities including a beautiful swimming pool and a fully equipped fitness center. Each apartment is designed with the finest features and finishes, including sleek granite countertops, stainless-steel appliances, and wood-style flooring in select homes. Enjoy a cozy sunroom area perfect for reading, working, or relaxing. Set sail for Melbourne and discover how good home can be at City Harbor.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f6c0d-69ab-702b-abde-fa9c45615d04.webp",
      "featured_image_media": {
        "alt_text": "Outdoor seating area with blue upholstered furniture and umbrellas overlooking a lake with a fountain.",
        "public_id": "019f6c0d-69ab-702b-abde-fa9c45615d04",
        "storage_key": "property/5694569974857728/019f6c0d-69ab-702b-abde-fa9c45615d04.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f6c0d-73a2-74ea-a915-c4d3d5575d0d.webp",
      "blank_image_media": {
        "alt_text": "Exterior of apartment building with a pool and lounge chairs.",
        "public_id": "019f6c0d-73a2-74ea-a915-c4d3d5575d0d",
        "storage_key": "property/5694569974857728/019f6c0d-73a2-74ea-a915-c4d3d5575d0d.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "City Harbor | Apartments For Rent In Melbourne FL Near Geospace Physics Laboratory",
      "seo_description": "Find apartments for rent in Melbourne FL near Geospace Physics Laboratory at City Harbor. Enjoy modern features, resort-style amenities, and a pet-friendly community near Mallards Landing Golf Course.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "source": "custom",
      "page_item_url": "apartments-for-rent-melbourne-fl-near-university-florida",
      "search_query": "Apartments For Rent In Melbourne FL Near University of Florida Surgeons",
      "category": "POI",
      "h1_title": "Apartments For Rent In Melbourne FL Near University of Florida Surgeons at City Harbor",
      "h2_subtitle": "Discover upscale living in a pet-friendly community near Mallards Landing Golf Course. Enjoy resort-style amenities and modern apartment features.",
      "page_copy": "Escape the ordinary and settle into something special with our apartments for rent in Melbourne FL near University of Florida Surgeons at City Harbor. Our upscale Melbourne, Florida, apartment community near Mallards Landing Golf Course features a quiet, park-like setting with its own private lake, secured VIP access, and resort-style amenities including a beautiful swimming pool and a fully equipped fitness center. Each apartment is designed with the finest features and finishes, including sleek granite countertops, stainless-steel appliances, and wood-style flooring in select homes. Enjoy a cozy sunroom area perfect for reading, working, or relaxing. Set sail for Melbourne and discover how good home can be at City Harbor.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f6c0d-69ab-702b-abde-fa9c45615d04.webp",
      "featured_image_media": {
        "alt_text": "Outdoor seating area with blue upholstered furniture and umbrellas overlooking a lake with a fountain.",
        "public_id": "019f6c0d-69ab-702b-abde-fa9c45615d04",
        "storage_key": "property/5694569974857728/019f6c0d-69ab-702b-abde-fa9c45615d04.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f6c0d-73a2-74ea-a915-c4d3d5575d0d.webp",
      "blank_image_media": {
        "alt_text": "Exterior of apartment building with a pool and lounge chairs.",
        "public_id": "019f6c0d-73a2-74ea-a915-c4d3d5575d0d",
        "storage_key": "property/5694569974857728/019f6c0d-73a2-74ea-a915-c4d3d5575d0d.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "City Harbor | Apartments For Rent In Melbourne FL Near University of Florida Surgeons",
      "seo_description": "Find apartments for rent in Melbourne FL near University of Florida Surgeons at City Harbor. Enjoy modern features, resort-style amenities, and a pet-friendly community near Mallards Landing Golf Course.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "source": "custom",
      "page_item_url": "apartments-for-rent-melbourne-fl-near-croton-school",
      "search_query": "Apartments For Rent In Melbourne FL Near Croton Elementary School",
      "category": "POI",
      "h1_title": "Apartments For Rent In Melbourne FL Near Croton Elementary School at City Harbor",
      "h2_subtitle": "Discover family-friendly living in a pet-friendly community near Mallards Landing Golf Course. Enjoy resort-style amenities and modern apartment features.",
      "page_copy": "Escape the ordinary and settle into something special with our apartments for rent in Melbourne FL near Croton Elementary School at City Harbor. Located just 3.1 km from Croton Elementary School, our community is perfect for families looking to reside in the Brevard County School District. Our upscale Melbourne, Florida, apartment community near Mallards Landing Golf Course features a quiet, park-like setting with its own private lake, secured VIP access, and resort-style amenities including a beautiful swimming pool and a fully equipped fitness center. Each apartment is designed with the finest features and finishes, including sleek granite countertops, stainless-steel appliances, and wood-style flooring in select homes. Enjoy a cozy sunroom area perfect for reading, working, or relaxing. Choose from one, two, or three bedroom floor plans and discover how good home can be at City Harbor.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f6c0d-69ab-702b-abde-fa9c45615d04.webp",
      "featured_image_media": {
        "alt_text": "Outdoor seating area with blue upholstered furniture and umbrellas overlooking a lake with a fountain.",
        "public_id": "019f6c0d-69ab-702b-abde-fa9c45615d04",
        "storage_key": "property/5694569974857728/019f6c0d-69ab-702b-abde-fa9c45615d04.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f6c0d-73a2-74ea-a915-c4d3d5575d0d.webp",
      "blank_image_media": {
        "alt_text": "Exterior of apartment building with a pool and lounge chairs.",
        "public_id": "019f6c0d-73a2-74ea-a915-c4d3d5575d0d",
        "storage_key": "property/5694569974857728/019f6c0d-73a2-74ea-a915-c4d3d5575d0d.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "City Harbor | Apartments For Rent In Melbourne FL Near Croton Elementary School",
      "seo_description": "Find apartments for rent in Melbourne FL near Croton Elementary School at City Harbor. Enjoy modern features, resort-style amenities, and a family-friendly community near Mallards Landing Golf Course.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "source": "custom",
      "page_item_url": "apartments-for-rent-melbourne-fl-near-dr-wj-creel",
      "search_query": "Apartments For Rent In Melbourne FL Near Dr WJ Creel Elementary School",
      "category": "POI",
      "h1_title": "Apartments For Rent In Melbourne FL Near Dr WJ Creel Elementary School at City Harbor",
      "h2_subtitle": "Discover family-friendly living in a pet-friendly community near Mallards Landing Golf Course. Enjoy resort-style amenities and modern apartment features.",
      "page_copy": "Escape the ordinary and settle into something special with our apartments for rent in Melbourne FL near Dr WJ Creel Elementary School at City Harbor. Located just 2.9 km from Dr WJ Creel Elementary School, our community is perfect for families looking to reside in the Brevard County School District. Our upscale Melbourne, Florida, apartment community near Mallards Landing Golf Course features a quiet, park-like setting with its own private lake, secured VIP access, and resort-style amenities including a beautiful swimming pool and a fully equipped fitness center. Each apartment is designed with the finest features and finishes, including sleek granite countertops, stainless-steel appliances, and wood-style flooring in select homes. Enjoy a cozy sunroom area perfect for reading, working, or relaxing. Choose from one, two, or three bedroom floor plans and discover how good home can be at City Harbor.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f6c0d-69ab-702b-abde-fa9c45615d04.webp",
      "featured_image_media": {
        "alt_text": "Outdoor seating area with blue upholstered furniture and umbrellas overlooking a lake with a fountain.",
        "public_id": "019f6c0d-69ab-702b-abde-fa9c45615d04",
        "storage_key": "property/5694569974857728/019f6c0d-69ab-702b-abde-fa9c45615d04.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f6c0d-73a2-74ea-a915-c4d3d5575d0d.webp",
      "blank_image_media": {
        "alt_text": "Exterior of apartment building with a pool and lounge chairs.",
        "public_id": "019f6c0d-73a2-74ea-a915-c4d3d5575d0d",
        "storage_key": "property/5694569974857728/019f6c0d-73a2-74ea-a915-c4d3d5575d0d.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "City Harbor | Apartments For Rent In Melbourne FL Near Dr WJ Creel Elementary School",
      "seo_description": "Find apartments for rent in Melbourne FL near Dr WJ Creel Elementary School at City Harbor. Enjoy modern features, resort-style amenities, and a family-friendly community near Mallards Landing Golf Course.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "source": "custom",
      "page_item_url": "apartments-for-rent-melbourne-fl-near-sabal-school",
      "search_query": "Apartments For Rent In Melbourne FL Near Sabal Elementary School",
      "category": "POI",
      "h1_title": "Apartments For Rent In Melbourne FL Near Sabal Elementary School at City Harbor",
      "h2_subtitle": "Discover family-friendly living in a pet-friendly community near Mallards Landing Golf Course. Enjoy resort-style amenities and modern apartment features.",
      "page_copy": "Escape the ordinary and settle into something special with our apartments for rent in Melbourne FL near Sabal Elementary School at City Harbor. Located just 2.6 km from Sabal Elementary School, our community is perfect for families looking to reside in a top-rated school district. Our upscale Melbourne, Florida, apartment community near Mallards Landing Golf Course features a quiet, park-like setting with its own private lake, secured VIP access, and resort-style amenities including a beautiful swimming pool and a fully equipped fitness center. Each apartment is designed with the finest features and finishes, including sleek granite countertops, stainless-steel appliances, and wood-style flooring in select homes. Enjoy a cozy sunroom area perfect for reading, working, or relaxing. Choose from one, two, or three bedroom floor plans and discover how good home can be at City Harbor.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f6c0d-69ab-702b-abde-fa9c45615d04.webp",
      "featured_image_media": {
        "alt_text": "Outdoor seating area with blue upholstered furniture and umbrellas overlooking a lake with a fountain.",
        "public_id": "019f6c0d-69ab-702b-abde-fa9c45615d04",
        "storage_key": "property/5694569974857728/019f6c0d-69ab-702b-abde-fa9c45615d04.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f6c0d-73a2-74ea-a915-c4d3d5575d0d.webp",
      "blank_image_media": {
        "alt_text": "Exterior of apartment building with a pool and lounge chairs.",
        "public_id": "019f6c0d-73a2-74ea-a915-c4d3d5575d0d",
        "storage_key": "property/5694569974857728/019f6c0d-73a2-74ea-a915-c4d3d5575d0d.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "City Harbor | Apartments For Rent In Melbourne FL Near Sabal Elementary School",
      "seo_description": "Find apartments for rent in Melbourne FL near Sabal Elementary School at City Harbor. Enjoy modern features, resort-style amenities, and a family-friendly community near Mallards Landing Golf Course.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "source": "custom",
      "page_item_url": "apartments-for-rent-melbourne-fl-near-roy-allen",
      "search_query": "Apartments For Rent In Melbourne FL Near Roy Allen Elementary School",
      "category": "POI",
      "h1_title": "Apartments For Rent In Melbourne FL Near Roy Allen Elementary School at City Harbor",
      "h2_subtitle": "Discover family-friendly living in a pet-friendly community near Mallards Landing Golf Course. Enjoy resort-style amenities and modern apartment features.",
      "page_copy": "Escape the ordinary and settle into something special with our apartments for rent in Melbourne FL near Roy Allen Elementary School at City Harbor. Located just 4.9 km from Roy Allen Elementary School, our community is perfect for families looking to reside in the Brevard County School District. Our upscale Melbourne, Florida, apartment community near Mallards Landing Golf Course features a quiet, park-like setting with its own private lake, secured VIP access, and resort-style amenities including a beautiful swimming pool and a fully equipped fitness center. Each apartment is designed with the finest features and finishes, including sleek granite countertops, stainless-steel appliances, and wood-style flooring in select homes. Enjoy a cozy sunroom area perfect for reading, working, or relaxing. Choose from one, two, or three bedroom floor plans and discover how good home can be at City Harbor.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f6c0d-69ab-702b-abde-fa9c45615d04.webp",
      "featured_image_media": {
        "alt_text": "Outdoor seating area with blue upholstered furniture and umbrellas overlooking a lake with a fountain.",
        "public_id": "019f6c0d-69ab-702b-abde-fa9c45615d04",
        "storage_key": "property/5694569974857728/019f6c0d-69ab-702b-abde-fa9c45615d04.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f6c0d-73a2-74ea-a915-c4d3d5575d0d.webp",
      "blank_image_media": {
        "alt_text": "Exterior of apartment building with a pool and lounge chairs.",
        "public_id": "019f6c0d-73a2-74ea-a915-c4d3d5575d0d",
        "storage_key": "property/5694569974857728/019f6c0d-73a2-74ea-a915-c4d3d5575d0d.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "City Harbor | Apartments For Rent In Melbourne FL Near Roy Allen Elementary School",
      "seo_description": "Find apartments for rent in Melbourne FL near Roy Allen Elementary School at City Harbor. Enjoy modern features, resort-style amenities, and a family-friendly community near Mallards Landing Golf Course.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "source": "custom",
      "page_item_url": "apartments-for-rent-melbourne-fl-near-harbor-city",
      "search_query": "Apartments For Rent In Melbourne FL Near Harbor City Elementary School",
      "category": "POI",
      "h1_title": "Apartments For Rent In Melbourne FL Near Harbor City Elementary School at City Harbor",
      "h2_subtitle": "Discover family-friendly living in a pet-friendly community near Mallards Landing Golf Course. Enjoy resort-style amenities and modern apartment features.",
      "page_copy": "Escape the ordinary and settle into something special with our apartments for rent in Melbourne FL near Harbor City Elementary School at City Harbor. Located just 5.3 km from Harbor City Elementary School, our community is perfect for families looking to reside in a top-rated school district. Our upscale Melbourne, Florida, apartment community near Mallards Landing Golf Course features a quiet, park-like setting with its own private lake, secured VIP access, and resort-style amenities including a beautiful swimming pool and a fully equipped fitness center. Each apartment is designed with the finest features and finishes, including sleek granite countertops, stainless-steel appliances, and wood-style flooring in select homes. Enjoy a cozy sunroom area perfect for reading, working, or relaxing. Choose from one, two, or three bedroom floor plans and discover how good home can be at City Harbor.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f6c0d-69ab-702b-abde-fa9c45615d04.webp",
      "featured_image_media": {
        "alt_text": "Outdoor seating area with blue upholstered furniture and umbrellas overlooking a lake with a fountain.",
        "public_id": "019f6c0d-69ab-702b-abde-fa9c45615d04",
        "storage_key": "property/5694569974857728/019f6c0d-69ab-702b-abde-fa9c45615d04.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f6c0d-73a2-74ea-a915-c4d3d5575d0d.webp",
      "blank_image_media": {
        "alt_text": "Exterior of apartment building with a pool and lounge chairs.",
        "public_id": "019f6c0d-73a2-74ea-a915-c4d3d5575d0d",
        "storage_key": "property/5694569974857728/019f6c0d-73a2-74ea-a915-c4d3d5575d0d.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "City Harbor | Apartments For Rent In Melbourne FL Near Harbor City Elementary School",
      "seo_description": "Find apartments for rent in Melbourne FL near Harbor City Elementary School at City Harbor. Enjoy modern features, resort-style amenities, and a family-friendly community near Mallards Landing Golf Course.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "source": "custom",
      "page_item_url": "apartments-for-rent-melbourne-fl-near-lyndon-johnson-school",
      "search_query": "Apartments For Rent In Melbourne FL Near Lyndon B. Johnson Middle School",
      "category": "POI",
      "h1_title": "Apartments For Rent In Melbourne FL Near Lyndon B. Johnson Middle School at City Harbor",
      "h2_subtitle": "Discover family-friendly living in a pet-friendly community near Mallards Landing Golf Course. Enjoy resort-style amenities and modern apartment features.",
      "page_copy": "Escape the ordinary and settle into something special with our apartments for rent in Melbourne FL near Lyndon B. Johnson Middle School at City Harbor. Located just 1.7 km from Lyndon B. Johnson Middle School, our community is perfect for families looking to reside in the Albuquerque Public Schools district. Our upscale Melbourne, Florida, apartment community near Mallards Landing Golf Course features a quiet, park-like setting with its own private lake, secured VIP access, and resort-style amenities including a beautiful swimming pool and a fully equipped fitness center. Each apartment is designed with the finest features and finishes, including sleek granite countertops, stainless-steel appliances, and wood-style flooring in select homes. Enjoy a cozy sunroom area perfect for reading, working, or relaxing. Choose from one, two, or three bedroom floor plans and discover how good home can be at City Harbor.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f6c0d-69ab-702b-abde-fa9c45615d04.webp",
      "featured_image_media": {
        "alt_text": "Outdoor seating area with blue upholstered furniture and umbrellas overlooking a lake with a fountain.",
        "public_id": "019f6c0d-69ab-702b-abde-fa9c45615d04",
        "storage_key": "property/5694569974857728/019f6c0d-69ab-702b-abde-fa9c45615d04.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f6c0d-73a2-74ea-a915-c4d3d5575d0d.webp",
      "blank_image_media": {
        "alt_text": "Exterior of apartment building with a pool and lounge chairs.",
        "public_id": "019f6c0d-73a2-74ea-a915-c4d3d5575d0d",
        "storage_key": "property/5694569974857728/019f6c0d-73a2-74ea-a915-c4d3d5575d0d.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "City Harbor | Apartments For Rent In Melbourne FL Near Lyndon B. Johnson Middle School",
      "seo_description": "Find apartments for rent in Melbourne FL near Lyndon B. Johnson Middle School at City Harbor. Enjoy modern features, resort-style amenities, and a family-friendly community near Mallards Landing Golf Course.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "source": "custom",
      "page_item_url": "apartments-for-rent-melbourne-fl-near-eau-gallie",
      "search_query": "Apartments For Rent In Melbourne FL Near Eau Gallie High School",
      "category": "POI",
      "h1_title": "Apartments For Rent In Melbourne FL Near Eau Gallie High School at City Harbor",
      "h2_subtitle": "Discover family-friendly living in a pet-friendly community near Mallards Landing Golf Course. Enjoy resort-style amenities and modern apartment features.",
      "page_copy": "Escape the ordinary and settle into something special with our apartments for rent in Melbourne FL near Eau Gallie High School at City Harbor. Located just 4.1 km from Eau Gallie High School, our community is perfect for families looking to reside in the Brevard County School District. Our upscale Melbourne, Florida, apartment community near Mallards Landing Golf Course features a quiet, park-like setting with its own private lake, secured VIP access, and resort-style amenities including a beautiful swimming pool and a fully equipped fitness center. Each apartment is designed with the finest features and finishes, including sleek granite countertops, stainless-steel appliances, and wood-style flooring in select homes. Enjoy a cozy sunroom area perfect for reading, working, or relaxing. Choose from one, two, or three bedroom floor plans and discover how good home can be at City Harbor.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f6c0d-69ab-702b-abde-fa9c45615d04.webp",
      "featured_image_media": {
        "alt_text": "Outdoor seating area with blue upholstered furniture and umbrellas overlooking a lake with a fountain.",
        "public_id": "019f6c0d-69ab-702b-abde-fa9c45615d04",
        "storage_key": "property/5694569974857728/019f6c0d-69ab-702b-abde-fa9c45615d04.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f6c0d-73a2-74ea-a915-c4d3d5575d0d.webp",
      "blank_image_media": {
        "alt_text": "Exterior of apartment building with a pool and lounge chairs.",
        "public_id": "019f6c0d-73a2-74ea-a915-c4d3d5575d0d",
        "storage_key": "property/5694569974857728/019f6c0d-73a2-74ea-a915-c4d3d5575d0d.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "City Harbor | Apartments For Rent In Melbourne FL Near Eau Gallie High School",
      "seo_description": "Find apartments for rent in Melbourne FL near Eau Gallie High School at City Harbor. Enjoy modern features, resort-style amenities, and a family-friendly community near Mallards Landing Golf Course.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5694569974857728",
      "source": "custom",
      "page_item_url": "apartments-for-rent-melbourne-fl-near-longleaf-school",
      "search_query": "Apartments For Rent In Melbourne FL Near Longleaf Elementary School",
      "category": "POI",
      "h1_title": "Apartments For Rent In Melbourne FL Near Longleaf Elementary School at City Harbor",
      "h2_subtitle": "Discover family-friendly living in a pet-friendly community near Mallards Landing Golf Course. Enjoy resort-style amenities and modern apartment features.",
      "page_copy": "Escape the ordinary and settle into something special with our apartments for rent in Melbourne FL near Longleaf Elementary School at City Harbor. Located just 4.7 km from Longleaf Elementary School, our community is perfect for families looking to reside in a top-rated school district. Our upscale Melbourne, Florida, apartment community near Mallards Landing Golf Course features a quiet, park-like setting with its own private lake, secured VIP access, and resort-style amenities including a beautiful swimming pool and a fully equipped fitness center. Each apartment is designed with the finest features and finishes, including sleek granite countertops, stainless-steel appliances, and wood-style flooring in select homes. Enjoy a cozy sunroom area perfect for reading, working, or relaxing. Choose from one, two, or three bedroom floor plans and discover how good home can be at City Harbor.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f6c0d-69ab-702b-abde-fa9c45615d04.webp",
      "featured_image_media": {
        "alt_text": "Outdoor seating area with blue upholstered furniture and umbrellas overlooking a lake with a fountain.",
        "public_id": "019f6c0d-69ab-702b-abde-fa9c45615d04",
        "storage_key": "property/5694569974857728/019f6c0d-69ab-702b-abde-fa9c45615d04.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019f6c0d-73a2-74ea-a915-c4d3d5575d0d.webp",
      "blank_image_media": {
        "alt_text": "Exterior of apartment building with a pool and lounge chairs.",
        "public_id": "019f6c0d-73a2-74ea-a915-c4d3d5575d0d",
        "storage_key": "property/5694569974857728/019f6c0d-73a2-74ea-a915-c4d3d5575d0d.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "City Harbor | Apartments For Rent In Melbourne FL Near Longleaf Elementary School",
      "seo_description": "Find apartments for rent in Melbourne FL near Longleaf Elementary School at City Harbor. Enjoy modern features, resort-style amenities, and a family-friendly community near Mallards Landing Golf Course.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "jordanh@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "2152"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "2376470879"
    },
    {
      "ID": "custom_leasing_ai",
      "type": "STRING",
      "value": "<script async src=\"https://cdn.leasing.ai/prod/v1/loader.js?pid=69db514f9eb73dfa48ba5a23\"></script>\n<img src=\"https://api.leasing.ai/v1/widgets/pixel/69db514f9eb73dfa48ba5a23\" width=\"1\" height=\"1\" style=\"display:none\" alt=\"\" />"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "4881700"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-MSF26PQ"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "1"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "full_stack"
    },
    {
      "ID": "custom_knock_company_id",
      "type": "STRING",
      "value": "3165"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "8443932491"
    },
    {
      "ID": "custom_knock_community_id",
      "type": "STRING",
      "value": "0a64dec8d2f611f1"
    },
    {
      "ID": "custom_knock_company_token",
      "type": "STRING",
      "value": "1f195820242ac1100a1b122d7087a021"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_engrain_sightmap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/n9w6mn7rv71"
    },
    {
      "ID": "custom_self_guided_tour_url",
      "type": "STRING",
      "value": "https://selftournow.com/property/c863a147-386c-412a-b40b-085c1dbf51cb"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "custom"
    },
    {
      "ID": "custom_knock_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "689-354-0654"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IkVZQ2ovNUpBQW85UkdkT0x0ajZtQUE9PSIsInZhbHVlIjoiVmNmYkh1cG9HY29MTUtXVHBnZEY3Zz09IiwibWFjIjoiNmFhNmJlNmZiOTEyOGFmNTZkNTE5NGFmNTYzZjMzODg5YmMxNTZkNjY5MmMzOTRiNDk0ZTY2YWRmNmZkNzY2NSJ9"
    },
    {
      "ID": "custom_household_income_qualification_multiplier",
      "type": "FLOAT",
      "value": "3"
    }
  ],
  "custom_csm": "jordanh@repli360.com",
  "custom_qb_id": "2152",
  "custom_repli_id": "2376470879",
  "custom_leasing_ai": "<script async src=\"https://cdn.leasing.ai/prod/v1/loader.js?pid=69db514f9eb73dfa48ba5a23\"></script>\n<img src=\"https://api.leasing.ai/v1/widgets/pixel/69db514f9eb73dfa48ba5a23\" width=\"1\" height=\"1\" style=\"display:none\" alt=\"\" />",
  "custom_realpage_id": "4881700",
  "custom_google_gtm_id": "GTM-MSF26PQ",
  "custom_rollout_phase": "1",
  "custom_ads_subscription": "full_stack",
  "custom_knock_company_id": "3165",
  "custom_seo_subscription": "essential",
  "custom_hubspot_company_id": "8443932491",
  "custom_knock_community_id": "0a64dec8d2f611f1",
  "custom_knock_company_token": "1f195820242ac1100a1b122d7087a021",
  "custom_social_subscription": "none",
  "custom_engrain_sightmap_url": "https://sightmap.com/embed/n9w6mn7rv71",
  "custom_self_guided_tour_url": "https://selftournow.com/property/c863a147-386c-412a-b40b-085c1dbf51cb",
  "custom_website_subscription": "custom",
  "custom_knock_tour_button_popup": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>",
  "custom_ppc_tracking_phone_number": "689-354-0654",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IkVZQ2ovNUpBQW85UkdkT0x0ajZtQUE9PSIsInZhbHVlIjoiVmNmYkh1cG9HY29MTUtXVHBnZEY3Zz09IiwibWFjIjoiNmFhNmJlNmZiOTEyOGFmNTZkNTE5NGFmNTYzZjMzODg5YmMxNTZkNjY5MmMzOTRiNDk0ZTY2YWRmNmZkNzY2NSJ9",
  "custom_household_income_qualification_multiplier": "3",
  "custom_audioeye_site_id": "cea7328c-63fe-4d63-90a8-53c66a310116",
  "custom_audioeye_site_hash": "94c11a9d81ea05149216de655aa612f0"
};

export const generatedAt = '2026-11-03T20:37:46.632Z';
